var items = {
  "block.minecraft.acacia_button": "㭜鈕",
  "block.minecraft.acacia_door": "㭜門",
  "block.minecraft.acacia_fence": "㭜檻",
  "block.minecraft.acacia_fence_gate": "㭜扉",
  "block.minecraft.acacia_hanging_sign": "㭜懸牌",
  "block.minecraft.acacia_leaves": "㭜葉",
  "block.minecraft.acacia_log": "㭜樁",
  "block.minecraft.acacia_planks": "㭜材",
  "block.minecraft.acacia_pressure_plate": "㭜踏板",
  "block.minecraft.acacia_sapling": "㭜秧",
  "block.minecraft.acacia_shelf": "㭜櫥",
  "block.minecraft.acacia_sign": "㭜牌",
  "block.minecraft.acacia_slab": "㭜版",
  "block.minecraft.acacia_stairs": "㭜階",
  "block.minecraft.acacia_trapdoor": "㭜窖門",
  "block.minecraft.acacia_wall_hanging_sign": "壁中㭜懸牌",
  "block.minecraft.acacia_wall_sign": "壁中㭜牌",
  "block.minecraft.acacia_wood": "㭜木",
  "block.minecraft.activator_rail": "激軌",
  "block.minecraft.air": "氣",
  "block.minecraft.allium": "碩蔥",
  "block.minecraft.amethyst_block": "紫水玉塊",
  "block.minecraft.amethyst_cluster": "紫水玉簇",
  "block.minecraft.ancient_debris": "上古之骸",
  "block.minecraft.andesite": "安山石",
  "block.minecraft.andesite_slab": "安山石版",
  "block.minecraft.andesite_stairs": "安山石階",
  "block.minecraft.andesite_wall": "安山石垣",
  "block.minecraft.anvil": "鐵砧",
  "block.minecraft.attached_melon_stem": "垂寒瓜莖",
  "block.minecraft.attached_pumpkin_stem": "垂南瓜莖",
  "block.minecraft.azalea": "杜鵑",
  "block.minecraft.azalea_leaves": "杜鵑葉",
  "block.minecraft.azure_bluet": "藍茜",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.bamboo_block": "竹塊",
  "block.minecraft.bamboo_button": "竹鈕",
  "block.minecraft.bamboo_door": "竹門",
  "block.minecraft.bamboo_fence": "竹檻",
  "block.minecraft.bamboo_fence_gate": "竹扉",
  "block.minecraft.bamboo_hanging_sign": "竹懸牌",
  "block.minecraft.bamboo_mosaic": "竹嵌工",
  "block.minecraft.bamboo_mosaic_slab": "竹嵌工版",
  "block.minecraft.bamboo_mosaic_stairs": "竹嵌工階",
  "block.minecraft.bamboo_planks": "竹材",
  "block.minecraft.bamboo_pressure_plate": "竹踏板",
  "block.minecraft.bamboo_sapling": "竹筍",
  "block.minecraft.bamboo_shelf": "竹櫥",
  "block.minecraft.bamboo_sign": "竹牌",
  "block.minecraft.bamboo_slab": "竹版",
  "block.minecraft.bamboo_stairs": "竹階",
  "block.minecraft.bamboo_trapdoor": "竹窖門",
  "block.minecraft.bamboo_wall_hanging_sign": "壁中竹懸牌",
  "block.minecraft.bamboo_wall_sign": "壁中竹牌",
  "block.minecraft.banner.base.black": "玄底",
  "block.minecraft.banner.base.blue": "靛底",
  "block.minecraft.banner.base.brown": "褐底",
  "block.minecraft.banner.base.cyan": "黛底",
  "block.minecraft.banner.base.gray": "灰底",
  "block.minecraft.banner.base.green": "綠底",
  "block.minecraft.banner.base.light_blue": "縹底",
  "block.minecraft.banner.base.light_gray": "蒼底",
  "block.minecraft.banner.base.lime": "翠底",
  "block.minecraft.banner.base.magenta": "赬底",
  "block.minecraft.banner.base.orange": "橙底",
  "block.minecraft.banner.base.pink": "紅底",
  "block.minecraft.banner.base.purple": "紫底",
  "block.minecraft.banner.base.red": "赤底",
  "block.minecraft.banner.base.white": "素底",
  "block.minecraft.banner.base.yellow": "黃底",
  "block.minecraft.banner.border.black": "玄匡",
  "block.minecraft.banner.border.blue": "靛匡",
  "block.minecraft.banner.border.brown": "褐匡",
  "block.minecraft.banner.border.cyan": "黛匡",
  "block.minecraft.banner.border.gray": "灰匡",
  "block.minecraft.banner.border.green": "綠匡",
  "block.minecraft.banner.border.light_blue": "縹匡",
  "block.minecraft.banner.border.light_gray": "蒼匡",
  "block.minecraft.banner.border.lime": "翠匡",
  "block.minecraft.banner.border.magenta": "赬匡",
  "block.minecraft.banner.border.orange": "橙匡",
  "block.minecraft.banner.border.pink": "紅匡",
  "block.minecraft.banner.border.purple": "紫匡",
  "block.minecraft.banner.border.red": "赤匡",
  "block.minecraft.banner.border.white": "素匡",
  "block.minecraft.banner.border.yellow": "黃匡",
  "block.minecraft.banner.bricks.black": "玄磚紋",
  "block.minecraft.banner.bricks.blue": "靛磚紋",
  "block.minecraft.banner.bricks.brown": "褐磚紋",
  "block.minecraft.banner.bricks.cyan": "黛磚紋",
  "block.minecraft.banner.bricks.gray": "灰磚紋",
  "block.minecraft.banner.bricks.green": "綠磚紋",
  "block.minecraft.banner.bricks.light_blue": "縹磚紋",
  "block.minecraft.banner.bricks.light_gray": "蒼磚紋",
  "block.minecraft.banner.bricks.lime": "翠磚紋",
  "block.minecraft.banner.bricks.magenta": "赬磚紋",
  "block.minecraft.banner.bricks.orange": "橙磚紋",
  "block.minecraft.banner.bricks.pink": "紅磚紋",
  "block.minecraft.banner.bricks.purple": "紫磚紋",
  "block.minecraft.banner.bricks.red": "赤磚紋",
  "block.minecraft.banner.bricks.white": "素磚紋",
  "block.minecraft.banner.bricks.yellow": "黃磚紋",
  "block.minecraft.banner.circle.black": "玄圈紋",
  "block.minecraft.banner.circle.blue": "靛圈紋",
  "block.minecraft.banner.circle.brown": "褐圈紋",
  "block.minecraft.banner.circle.cyan": "黛圈紋",
  "block.minecraft.banner.circle.gray": "灰圈紋",
  "block.minecraft.banner.circle.green": "綠圈紋",
  "block.minecraft.banner.circle.light_blue": "縹圈紋",
  "block.minecraft.banner.circle.light_gray": "蒼圈紋",
  "block.minecraft.banner.circle.lime": "翠圈紋",
  "block.minecraft.banner.circle.magenta": "赬圈紋",
  "block.minecraft.banner.circle.orange": "橙圈紋",
  "block.minecraft.banner.circle.pink": "紅圈紋",
  "block.minecraft.banner.circle.purple": "紫圈紋",
  "block.minecraft.banner.circle.red": "赤圈紋",
  "block.minecraft.banner.circle.white": "素圈紋",
  "block.minecraft.banner.circle.yellow": "黃圈紋",
  "block.minecraft.banner.creeper.black": "玄伏臨紋",
  "block.minecraft.banner.creeper.blue": "靛伏臨紋",
  "block.minecraft.banner.creeper.brown": "褐伏臨紋",
  "block.minecraft.banner.creeper.cyan": "黛伏臨紋",
  "block.minecraft.banner.creeper.gray": "灰伏臨紋",
  "block.minecraft.banner.creeper.green": "綠伏臨紋",
  "block.minecraft.banner.creeper.light_blue": "縹伏臨紋",
  "block.minecraft.banner.creeper.light_gray": "蒼伏臨紋",
  "block.minecraft.banner.creeper.lime": "翠伏臨紋",
  "block.minecraft.banner.creeper.magenta": "赬伏臨紋",
  "block.minecraft.banner.creeper.orange": "橙伏臨紋",
  "block.minecraft.banner.creeper.pink": "紅伏臨紋",
  "block.minecraft.banner.creeper.purple": "紫伏臨紋",
  "block.minecraft.banner.creeper.red": "赤伏臨紋",
  "block.minecraft.banner.creeper.white": "素伏臨紋",
  "block.minecraft.banner.creeper.yellow": "黃伏臨紋",
  "block.minecraft.banner.cross.black": "玄阡陌",
  "block.minecraft.banner.cross.blue": "靛阡陌",
  "block.minecraft.banner.cross.brown": "褐阡陌",
  "block.minecraft.banner.cross.cyan": "黛阡陌",
  "block.minecraft.banner.cross.gray": "灰阡陌",
  "block.minecraft.banner.cross.green": "綠阡陌",
  "block.minecraft.banner.cross.light_blue": "縹阡陌",
  "block.minecraft.banner.cross.light_gray": "蒼阡陌",
  "block.minecraft.banner.cross.lime": "翠阡陌",
  "block.minecraft.banner.cross.magenta": "赬阡陌",
  "block.minecraft.banner.cross.orange": "橙阡陌",
  "block.minecraft.banner.cross.pink": "紅阡陌",
  "block.minecraft.banner.cross.purple": "紫阡陌",
  "block.minecraft.banner.cross.red": "赤阡陌",
  "block.minecraft.banner.cross.white": "素阡陌",
  "block.minecraft.banner.cross.yellow": "黃阡陌",
  "block.minecraft.banner.curly_border.black": "玄齒匡",
  "block.minecraft.banner.curly_border.blue": "靛齒匡",
  "block.minecraft.banner.curly_border.brown": "褐齒匡",
  "block.minecraft.banner.curly_border.cyan": "黛齒匡",
  "block.minecraft.banner.curly_border.gray": "灰齒匡",
  "block.minecraft.banner.curly_border.green": "綠齒匡",
  "block.minecraft.banner.curly_border.light_blue": "縹齒匡",
  "block.minecraft.banner.curly_border.light_gray": "蒼齒匡",
  "block.minecraft.banner.curly_border.lime": "翠齒匡",
  "block.minecraft.banner.curly_border.magenta": "赬齒匡",
  "block.minecraft.banner.curly_border.orange": "橙齒匡",
  "block.minecraft.banner.curly_border.pink": "紅齒匡",
  "block.minecraft.banner.curly_border.purple": "紫齒匡",
  "block.minecraft.banner.curly_border.red": "赤齒匡",
  "block.minecraft.banner.curly_border.white": "素齒匡",
  "block.minecraft.banner.curly_border.yellow": "黃齒匡",
  "block.minecraft.banner.diagonal_left.black": "右頂玄緞",
  "block.minecraft.banner.diagonal_left.blue": "右頂靛緞",
  "block.minecraft.banner.diagonal_left.brown": "右頂褐緞",
  "block.minecraft.banner.diagonal_left.cyan": "右頂黛緞",
  "block.minecraft.banner.diagonal_left.gray": "右頂灰緞",
  "block.minecraft.banner.diagonal_left.green": "右頂綠緞",
  "block.minecraft.banner.diagonal_left.light_blue": "右頂縹緞",
  "block.minecraft.banner.diagonal_left.light_gray": "右頂蒼緞",
  "block.minecraft.banner.diagonal_left.lime": "右頂翠緞",
  "block.minecraft.banner.diagonal_left.magenta": "右頂赬緞",
  "block.minecraft.banner.diagonal_left.orange": "右頂橙緞",
  "block.minecraft.banner.diagonal_left.pink": "右頂紅緞",
  "block.minecraft.banner.diagonal_left.purple": "右頂紫緞",
  "block.minecraft.banner.diagonal_left.red": "右頂赤緞",
  "block.minecraft.banner.diagonal_left.white": "右頂素緞",
  "block.minecraft.banner.diagonal_left.yellow": "右頂黃緞",
  "block.minecraft.banner.diagonal_right.black": "左頂玄緞",
  "block.minecraft.banner.diagonal_right.blue": "左頂靛緞",
  "block.minecraft.banner.diagonal_right.brown": "左頂褐緞",
  "block.minecraft.banner.diagonal_right.cyan": "左頂黛緞",
  "block.minecraft.banner.diagonal_right.gray": "左頂灰緞",
  "block.minecraft.banner.diagonal_right.green": "左頂綠緞",
  "block.minecraft.banner.diagonal_right.light_blue": "左頂縹緞",
  "block.minecraft.banner.diagonal_right.light_gray": "左頂蒼緞",
  "block.minecraft.banner.diagonal_right.lime": "左頂翠緞",
  "block.minecraft.banner.diagonal_right.magenta": "左頂赬緞",
  "block.minecraft.banner.diagonal_right.orange": "左頂橙緞",
  "block.minecraft.banner.diagonal_right.pink": "左頂紅緞",
  "block.minecraft.banner.diagonal_right.purple": "左頂紫緞",
  "block.minecraft.banner.diagonal_right.red": "左頂赤緞",
  "block.minecraft.banner.diagonal_right.white": "左頂素緞",
  "block.minecraft.banner.diagonal_right.yellow": "左頂黃緞",
  "block.minecraft.banner.diagonal_up_left.black": "右底玄緞",
  "block.minecraft.banner.diagonal_up_left.blue": "右底靛緞",
  "block.minecraft.banner.diagonal_up_left.brown": "右底褐緞",
  "block.minecraft.banner.diagonal_up_left.cyan": "右底黛緞",
  "block.minecraft.banner.diagonal_up_left.gray": "右底灰緞",
  "block.minecraft.banner.diagonal_up_left.green": "右底綠緞",
  "block.minecraft.banner.diagonal_up_left.light_blue": "右底縹緞",
  "block.minecraft.banner.diagonal_up_left.light_gray": "右底蒼緞",
  "block.minecraft.banner.diagonal_up_left.lime": "右底翠緞",
  "block.minecraft.banner.diagonal_up_left.magenta": "右底赬緞",
  "block.minecraft.banner.diagonal_up_left.orange": "右底橙緞",
  "block.minecraft.banner.diagonal_up_left.pink": "右底紅緞",
  "block.minecraft.banner.diagonal_up_left.purple": "右底紫緞",
  "block.minecraft.banner.diagonal_up_left.red": "右底赤緞",
  "block.minecraft.banner.diagonal_up_left.white": "右底素緞",
  "block.minecraft.banner.diagonal_up_left.yellow": "右底黃緞",
  "block.minecraft.banner.diagonal_up_right.black": "左底玄緞",
  "block.minecraft.banner.diagonal_up_right.blue": "左底靛緞",
  "block.minecraft.banner.diagonal_up_right.brown": "左底褐緞",
  "block.minecraft.banner.diagonal_up_right.cyan": "左底黛緞",
  "block.minecraft.banner.diagonal_up_right.gray": "左底灰緞",
  "block.minecraft.banner.diagonal_up_right.green": "左底綠緞",
  "block.minecraft.banner.diagonal_up_right.light_blue": "左底縹緞",
  "block.minecraft.banner.diagonal_up_right.light_gray": "左底蒼緞",
  "block.minecraft.banner.diagonal_up_right.lime": "左底翠緞",
  "block.minecraft.banner.diagonal_up_right.magenta": "左底赬緞",
  "block.minecraft.banner.diagonal_up_right.orange": "左底橙緞",
  "block.minecraft.banner.diagonal_up_right.pink": "左底紅緞",
  "block.minecraft.banner.diagonal_up_right.purple": "左底紫緞",
  "block.minecraft.banner.diagonal_up_right.red": "左底赤緞",
  "block.minecraft.banner.diagonal_up_right.white": "左底素緞",
  "block.minecraft.banner.diagonal_up_right.yellow": "左底黃緞",
  "block.minecraft.banner.flow.black": "玄氣洄紋",
  "block.minecraft.banner.flow.blue": "靛氣洄紋",
  "block.minecraft.banner.flow.brown": "褐氣洄紋",
  "block.minecraft.banner.flow.cyan": "黛氣洄紋",
  "block.minecraft.banner.flow.gray": "灰氣洄紋",
  "block.minecraft.banner.flow.green": "綠氣洄紋",
  "block.minecraft.banner.flow.light_blue": "縹氣洄紋",
  "block.minecraft.banner.flow.light_gray": "蒼氣洄紋",
  "block.minecraft.banner.flow.lime": "翠氣洄紋",
  "block.minecraft.banner.flow.magenta": "赬氣洄紋",
  "block.minecraft.banner.flow.orange": "橙氣洄紋",
  "block.minecraft.banner.flow.pink": "紅氣洄紋",
  "block.minecraft.banner.flow.purple": "紫氣洄紋",
  "block.minecraft.banner.flow.red": "赤氣洄紋",
  "block.minecraft.banner.flow.white": "素氣洄紋",
  "block.minecraft.banner.flow.yellow": "黃氣洄紋",
  "block.minecraft.banner.flower.black": "玄花紋",
  "block.minecraft.banner.flower.blue": "靛花紋",
  "block.minecraft.banner.flower.brown": "褐花紋",
  "block.minecraft.banner.flower.cyan": "黛花紋",
  "block.minecraft.banner.flower.gray": "灰花紋",
  "block.minecraft.banner.flower.green": "綠花紋",
  "block.minecraft.banner.flower.light_blue": "縹花紋",
  "block.minecraft.banner.flower.light_gray": "蒼花紋",
  "block.minecraft.banner.flower.lime": "翠花紋",
  "block.minecraft.banner.flower.magenta": "赬花紋",
  "block.minecraft.banner.flower.orange": "橙花紋",
  "block.minecraft.banner.flower.pink": "紅花紋",
  "block.minecraft.banner.flower.purple": "紫花紋",
  "block.minecraft.banner.flower.red": "赤花紋",
  "block.minecraft.banner.flower.white": "素花紋",
  "block.minecraft.banner.flower.yellow": "黃花紋",
  "block.minecraft.banner.globe.black": "玄坤輿紋",
  "block.minecraft.banner.globe.blue": "靛坤輿紋",
  "block.minecraft.banner.globe.brown": "褐坤輿紋",
  "block.minecraft.banner.globe.cyan": "黛坤輿紋",
  "block.minecraft.banner.globe.gray": "灰坤輿紋",
  "block.minecraft.banner.globe.green": "綠坤輿紋",
  "block.minecraft.banner.globe.light_blue": "縹坤輿紋",
  "block.minecraft.banner.globe.light_gray": "蒼坤輿紋",
  "block.minecraft.banner.globe.lime": "翠坤輿紋",
  "block.minecraft.banner.globe.magenta": "赬坤輿紋",
  "block.minecraft.banner.globe.orange": "橙坤輿紋",
  "block.minecraft.banner.globe.pink": "紅坤輿紋",
  "block.minecraft.banner.globe.purple": "紫坤輿紋",
  "block.minecraft.banner.globe.red": "赤坤輿紋",
  "block.minecraft.banner.globe.white": "素坤輿紋",
  "block.minecraft.banner.globe.yellow": "黃坤輿紋",
  "block.minecraft.banner.gradient.black": "玄底傾",
  "block.minecraft.banner.gradient.blue": "靛底傾",
  "block.minecraft.banner.gradient.brown": "褐底傾",
  "block.minecraft.banner.gradient.cyan": "黛底傾",
  "block.minecraft.banner.gradient.gray": "灰底傾",
  "block.minecraft.banner.gradient.green": "綠底傾",
  "block.minecraft.banner.gradient.light_blue": "縹底傾",
  "block.minecraft.banner.gradient.light_gray": "蒼底傾",
  "block.minecraft.banner.gradient.lime": "翠底傾",
  "block.minecraft.banner.gradient.magenta": "赬底傾",
  "block.minecraft.banner.gradient.orange": "橙底傾",
  "block.minecraft.banner.gradient.pink": "紅底傾",
  "block.minecraft.banner.gradient.purple": "紫底傾",
  "block.minecraft.banner.gradient.red": "赤底傾",
  "block.minecraft.banner.gradient.white": "素底傾",
  "block.minecraft.banner.gradient.yellow": "黃底傾",
  "block.minecraft.banner.gradient_up.black": "玄頂傾",
  "block.minecraft.banner.gradient_up.blue": "靛頂傾",
  "block.minecraft.banner.gradient_up.brown": "褐頂傾",
  "block.minecraft.banner.gradient_up.cyan": "黛頂傾",
  "block.minecraft.banner.gradient_up.gray": "灰頂傾",
  "block.minecraft.banner.gradient_up.green": "綠頂傾",
  "block.minecraft.banner.gradient_up.light_blue": "縹頂傾",
  "block.minecraft.banner.gradient_up.light_gray": "蒼頂傾",
  "block.minecraft.banner.gradient_up.lime": "翠頂傾",
  "block.minecraft.banner.gradient_up.magenta": "赬頂傾",
  "block.minecraft.banner.gradient_up.orange": "橙頂傾",
  "block.minecraft.banner.gradient_up.pink": "紅頂傾",
  "block.minecraft.banner.gradient_up.purple": "紫頂傾",
  "block.minecraft.banner.gradient_up.red": "赤頂傾",
  "block.minecraft.banner.gradient_up.white": "素頂傾",
  "block.minecraft.banner.gradient_up.yellow": "黃頂傾",
  "block.minecraft.banner.guster.black": "玄飆紋",
  "block.minecraft.banner.guster.blue": "靛飆紋",
  "block.minecraft.banner.guster.brown": "褐飆紋",
  "block.minecraft.banner.guster.cyan": "黛飆紋",
  "block.minecraft.banner.guster.gray": "灰飆紋",
  "block.minecraft.banner.guster.green": "綠飆紋",
  "block.minecraft.banner.guster.light_blue": "縹飆紋",
  "block.minecraft.banner.guster.light_gray": "蒼飆紋",
  "block.minecraft.banner.guster.lime": "翠飆紋",
  "block.minecraft.banner.guster.magenta": "赬飆紋",
  "block.minecraft.banner.guster.orange": "橙飆紋",
  "block.minecraft.banner.guster.pink": "紅飆紋",
  "block.minecraft.banner.guster.purple": "紫飆紋",
  "block.minecraft.banner.guster.red": "赤飆紋",
  "block.minecraft.banner.guster.white": "素飆紋",
  "block.minecraft.banner.guster.yellow": "黃飆紋",
  "block.minecraft.banner.half_horizontal.black": "頂玄緞",
  "block.minecraft.banner.half_horizontal.blue": "頂靛緞",
  "block.minecraft.banner.half_horizontal.brown": "頂褐緞",
  "block.minecraft.banner.half_horizontal.cyan": "頂黛緞",
  "block.minecraft.banner.half_horizontal.gray": "頂灰緞",
  "block.minecraft.banner.half_horizontal.green": "頂綠緞",
  "block.minecraft.banner.half_horizontal.light_blue": "頂縹緞",
  "block.minecraft.banner.half_horizontal.light_gray": "頂蒼緞",
  "block.minecraft.banner.half_horizontal.lime": "頂翠緞",
  "block.minecraft.banner.half_horizontal.magenta": "頂赬緞",
  "block.minecraft.banner.half_horizontal.orange": "頂橙緞",
  "block.minecraft.banner.half_horizontal.pink": "頂紅緞",
  "block.minecraft.banner.half_horizontal.purple": "頂紫緞",
  "block.minecraft.banner.half_horizontal.red": "頂赤緞",
  "block.minecraft.banner.half_horizontal.white": "頂素緞",
  "block.minecraft.banner.half_horizontal.yellow": "頂黃緞",
  "block.minecraft.banner.half_horizontal_bottom.black": "底玄緞",
  "block.minecraft.banner.half_horizontal_bottom.blue": "底靛緞",
  "block.minecraft.banner.half_horizontal_bottom.brown": "底褐緞",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "底黛緞",
  "block.minecraft.banner.half_horizontal_bottom.gray": "底灰緞",
  "block.minecraft.banner.half_horizontal_bottom.green": "底綠緞",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "底縹緞",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "底蒼緞",
  "block.minecraft.banner.half_horizontal_bottom.lime": "底翠緞",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "底赬緞",
  "block.minecraft.banner.half_horizontal_bottom.orange": "底橙緞",
  "block.minecraft.banner.half_horizontal_bottom.pink": "底紅緞",
  "block.minecraft.banner.half_horizontal_bottom.purple": "底紫緞",
  "block.minecraft.banner.half_horizontal_bottom.red": "底赤緞",
  "block.minecraft.banner.half_horizontal_bottom.white": "底素緞",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "底黃緞",
  "block.minecraft.banner.half_vertical.black": "右玄縱",
  "block.minecraft.banner.half_vertical.blue": "右靛縱",
  "block.minecraft.banner.half_vertical.brown": "右褐縱",
  "block.minecraft.banner.half_vertical.cyan": "右黛縱",
  "block.minecraft.banner.half_vertical.gray": "右灰縱",
  "block.minecraft.banner.half_vertical.green": "右綠縱",
  "block.minecraft.banner.half_vertical.light_blue": "右縹縱",
  "block.minecraft.banner.half_vertical.light_gray": "右蒼縱",
  "block.minecraft.banner.half_vertical.lime": "右翠縱",
  "block.minecraft.banner.half_vertical.magenta": "右赬縱",
  "block.minecraft.banner.half_vertical.orange": "右橙縱",
  "block.minecraft.banner.half_vertical.pink": "右紅縱",
  "block.minecraft.banner.half_vertical.purple": "右紫縱",
  "block.minecraft.banner.half_vertical.red": "右赤縱",
  "block.minecraft.banner.half_vertical.white": "右素縱",
  "block.minecraft.banner.half_vertical.yellow": "右黃縱",
  "block.minecraft.banner.half_vertical_right.black": "左玄縱",
  "block.minecraft.banner.half_vertical_right.blue": "左靛縱",
  "block.minecraft.banner.half_vertical_right.brown": "左褐縱",
  "block.minecraft.banner.half_vertical_right.cyan": "左黛縱",
  "block.minecraft.banner.half_vertical_right.gray": "左灰縱",
  "block.minecraft.banner.half_vertical_right.green": "左綠縱",
  "block.minecraft.banner.half_vertical_right.light_blue": "左縹縱",
  "block.minecraft.banner.half_vertical_right.light_gray": "左蒼縱",
  "block.minecraft.banner.half_vertical_right.lime": "左翠縱",
  "block.minecraft.banner.half_vertical_right.magenta": "左赬縱",
  "block.minecraft.banner.half_vertical_right.orange": "左橙縱",
  "block.minecraft.banner.half_vertical_right.pink": "左紅縱",
  "block.minecraft.banner.half_vertical_right.purple": "左紫縱",
  "block.minecraft.banner.half_vertical_right.red": "左赤縱",
  "block.minecraft.banner.half_vertical_right.white": "左素縱",
  "block.minecraft.banner.half_vertical_right.yellow": "左黃縱",
  "block.minecraft.banner.mojang.black": "黑魔贊紋",
  "block.minecraft.banner.mojang.blue": "靛魔贊紋",
  "block.minecraft.banner.mojang.brown": "褐魔贊紋",
  "block.minecraft.banner.mojang.cyan": "黛魔贊紋",
  "block.minecraft.banner.mojang.gray": "灰魔贊紋",
  "block.minecraft.banner.mojang.green": "綠魔贊紋",
  "block.minecraft.banner.mojang.light_blue": "縹魔贊紋",
  "block.minecraft.banner.mojang.light_gray": "蒼魔贊紋",
  "block.minecraft.banner.mojang.lime": "翠魔贊紋",
  "block.minecraft.banner.mojang.magenta": "赬魔贊紋",
  "block.minecraft.banner.mojang.orange": "橙魔贊紋",
  "block.minecraft.banner.mojang.pink": "紅魔贊紋",
  "block.minecraft.banner.mojang.purple": "紫魔贊紋",
  "block.minecraft.banner.mojang.red": "赤魔贊紋",
  "block.minecraft.banner.mojang.white": "白魔贊紋",
  "block.minecraft.banner.mojang.yellow": "黃魔贊紋",
  "block.minecraft.banner.piglin.black": "玄豕鼻",
  "block.minecraft.banner.piglin.blue": "靛豕鼻",
  "block.minecraft.banner.piglin.brown": "褐豕鼻",
  "block.minecraft.banner.piglin.cyan": "黛豕鼻",
  "block.minecraft.banner.piglin.gray": "灰豕鼻",
  "block.minecraft.banner.piglin.green": "綠豕鼻",
  "block.minecraft.banner.piglin.light_blue": "縹豕鼻",
  "block.minecraft.banner.piglin.light_gray": "蒼豕鼻",
  "block.minecraft.banner.piglin.lime": "翠豕鼻",
  "block.minecraft.banner.piglin.magenta": "赬豕鼻",
  "block.minecraft.banner.piglin.orange": "橙豕鼻",
  "block.minecraft.banner.piglin.pink": "紅豕鼻",
  "block.minecraft.banner.piglin.purple": "紫豕鼻",
  "block.minecraft.banner.piglin.red": "赤豕鼻",
  "block.minecraft.banner.piglin.white": "素豕鼻",
  "block.minecraft.banner.piglin.yellow": "黃豕鼻",
  "block.minecraft.banner.rhombus.black": "玄菱形",
  "block.minecraft.banner.rhombus.blue": "靛菱形",
  "block.minecraft.banner.rhombus.brown": "褐菱形",
  "block.minecraft.banner.rhombus.cyan": "黛菱形",
  "block.minecraft.banner.rhombus.gray": "灰菱形",
  "block.minecraft.banner.rhombus.green": "綠菱形",
  "block.minecraft.banner.rhombus.light_blue": "縹菱形",
  "block.minecraft.banner.rhombus.light_gray": "蒼菱形",
  "block.minecraft.banner.rhombus.lime": "翠菱形",
  "block.minecraft.banner.rhombus.magenta": "赬菱形",
  "block.minecraft.banner.rhombus.orange": "橙菱形",
  "block.minecraft.banner.rhombus.pink": "紅菱形",
  "block.minecraft.banner.rhombus.purple": "紫菱形",
  "block.minecraft.banner.rhombus.red": "赤菱形",
  "block.minecraft.banner.rhombus.white": "素菱形",
  "block.minecraft.banner.rhombus.yellow": "黃菱形",
  "block.minecraft.banner.skull.black": "玄髑顱紋",
  "block.minecraft.banner.skull.blue": "靛髑顱紋",
  "block.minecraft.banner.skull.brown": "褐髑顱紋",
  "block.minecraft.banner.skull.cyan": "黛髑顱紋",
  "block.minecraft.banner.skull.gray": "灰髑顱紋",
  "block.minecraft.banner.skull.green": "綠髑顱紋",
  "block.minecraft.banner.skull.light_blue": "縹髑顱紋",
  "block.minecraft.banner.skull.light_gray": "蒼髑顱紋",
  "block.minecraft.banner.skull.lime": "翠髑顱紋",
  "block.minecraft.banner.skull.magenta": "赬髑顱紋",
  "block.minecraft.banner.skull.orange": "橙髑顱紋",
  "block.minecraft.banner.skull.pink": "紅髑顱紋",
  "block.minecraft.banner.skull.purple": "紫髑顱紋",
  "block.minecraft.banner.skull.red": "赤髑顱紋",
  "block.minecraft.banner.skull.white": "素髑顱紋",
  "block.minecraft.banner.skull.yellow": "黃髑顱紋",
  "block.minecraft.banner.small_stripes.black": "直玄緞",
  "block.minecraft.banner.small_stripes.blue": "直靛緞",
  "block.minecraft.banner.small_stripes.brown": "直褐緞",
  "block.minecraft.banner.small_stripes.cyan": "直黛緞",
  "block.minecraft.banner.small_stripes.gray": "直灰緞",
  "block.minecraft.banner.small_stripes.green": "直綠緞",
  "block.minecraft.banner.small_stripes.light_blue": "直縹緞",
  "block.minecraft.banner.small_stripes.light_gray": "直蒼緞",
  "block.minecraft.banner.small_stripes.lime": "直翠緞",
  "block.minecraft.banner.small_stripes.magenta": "直赬緞",
  "block.minecraft.banner.small_stripes.orange": "直橙緞",
  "block.minecraft.banner.small_stripes.pink": "直紅緞",
  "block.minecraft.banner.small_stripes.purple": "直紫緞",
  "block.minecraft.banner.small_stripes.red": "直赤緞",
  "block.minecraft.banner.small_stripes.white": "直素緞",
  "block.minecraft.banner.small_stripes.yellow": "直黃緞",
  "block.minecraft.banner.square_bottom_left.black": "右底玄方",
  "block.minecraft.banner.square_bottom_left.blue": "右底靛方",
  "block.minecraft.banner.square_bottom_left.brown": "右底褐方",
  "block.minecraft.banner.square_bottom_left.cyan": "右底黛方",
  "block.minecraft.banner.square_bottom_left.gray": "右底灰方",
  "block.minecraft.banner.square_bottom_left.green": "右底綠方",
  "block.minecraft.banner.square_bottom_left.light_blue": "右底縹方",
  "block.minecraft.banner.square_bottom_left.light_gray": "右底蒼方",
  "block.minecraft.banner.square_bottom_left.lime": "右底翠方",
  "block.minecraft.banner.square_bottom_left.magenta": "右底赬方",
  "block.minecraft.banner.square_bottom_left.orange": "右底橙方",
  "block.minecraft.banner.square_bottom_left.pink": "右底紅方",
  "block.minecraft.banner.square_bottom_left.purple": "右底紫方",
  "block.minecraft.banner.square_bottom_left.red": "右底赤方",
  "block.minecraft.banner.square_bottom_left.white": "右底素方",
  "block.minecraft.banner.square_bottom_left.yellow": "右底黃方",
  "block.minecraft.banner.square_bottom_right.black": "左底玄方",
  "block.minecraft.banner.square_bottom_right.blue": "左底靛方",
  "block.minecraft.banner.square_bottom_right.brown": "左底褐方",
  "block.minecraft.banner.square_bottom_right.cyan": "左底黛方",
  "block.minecraft.banner.square_bottom_right.gray": "左底灰方",
  "block.minecraft.banner.square_bottom_right.green": "左底綠方",
  "block.minecraft.banner.square_bottom_right.light_blue": "左底縹方",
  "block.minecraft.banner.square_bottom_right.light_gray": "左底蒼方",
  "block.minecraft.banner.square_bottom_right.lime": "左底翠方",
  "block.minecraft.banner.square_bottom_right.magenta": "左底赬方",
  "block.minecraft.banner.square_bottom_right.orange": "左底橙方",
  "block.minecraft.banner.square_bottom_right.pink": "左底紅方",
  "block.minecraft.banner.square_bottom_right.purple": "左底紫方",
  "block.minecraft.banner.square_bottom_right.red": "左底赤方",
  "block.minecraft.banner.square_bottom_right.white": "左底素方",
  "block.minecraft.banner.square_bottom_right.yellow": "左底黃方",
  "block.minecraft.banner.square_top_left.black": "右頂玄方",
  "block.minecraft.banner.square_top_left.blue": "右頂靛方",
  "block.minecraft.banner.square_top_left.brown": "右頂褐方",
  "block.minecraft.banner.square_top_left.cyan": "右頂黛方",
  "block.minecraft.banner.square_top_left.gray": "右頂灰方",
  "block.minecraft.banner.square_top_left.green": "右頂綠方",
  "block.minecraft.banner.square_top_left.light_blue": "右頂縹方",
  "block.minecraft.banner.square_top_left.light_gray": "右頂蒼方",
  "block.minecraft.banner.square_top_left.lime": "右頂翠方",
  "block.minecraft.banner.square_top_left.magenta": "右頂赬方",
  "block.minecraft.banner.square_top_left.orange": "右頂橙方",
  "block.minecraft.banner.square_top_left.pink": "右頂紅方",
  "block.minecraft.banner.square_top_left.purple": "右頂紫方",
  "block.minecraft.banner.square_top_left.red": "右頂赤方",
  "block.minecraft.banner.square_top_left.white": "右頂素方",
  "block.minecraft.banner.square_top_left.yellow": "右頂黃方",
  "block.minecraft.banner.square_top_right.black": "左頂玄方",
  "block.minecraft.banner.square_top_right.blue": "左頂靛方",
  "block.minecraft.banner.square_top_right.brown": "左頂褐方",
  "block.minecraft.banner.square_top_right.cyan": "左頂黛方",
  "block.minecraft.banner.square_top_right.gray": "左頂灰方",
  "block.minecraft.banner.square_top_right.green": "左頂綠方",
  "block.minecraft.banner.square_top_right.light_blue": "左頂縹方",
  "block.minecraft.banner.square_top_right.light_gray": "左頂蒼方",
  "block.minecraft.banner.square_top_right.lime": "左頂翠方",
  "block.minecraft.banner.square_top_right.magenta": "左頂赬方",
  "block.minecraft.banner.square_top_right.orange": "左頂橙方",
  "block.minecraft.banner.square_top_right.pink": "左頂紅方",
  "block.minecraft.banner.square_top_right.purple": "左頂紫方",
  "block.minecraft.banner.square_top_right.red": "左頂赤方",
  "block.minecraft.banner.square_top_right.white": "左頂素方",
  "block.minecraft.banner.square_top_right.yellow": "左頂黃方",
  "block.minecraft.banner.straight_cross.black": "玄錯",
  "block.minecraft.banner.straight_cross.blue": "靛錯",
  "block.minecraft.banner.straight_cross.brown": "褐錯",
  "block.minecraft.banner.straight_cross.cyan": "黛錯",
  "block.minecraft.banner.straight_cross.gray": "灰錯",
  "block.minecraft.banner.straight_cross.green": "綠錯",
  "block.minecraft.banner.straight_cross.light_blue": "縹錯",
  "block.minecraft.banner.straight_cross.light_gray": "蒼錯",
  "block.minecraft.banner.straight_cross.lime": "翠錯",
  "block.minecraft.banner.straight_cross.magenta": "赬錯",
  "block.minecraft.banner.straight_cross.orange": "橙錯",
  "block.minecraft.banner.straight_cross.pink": "紅錯",
  "block.minecraft.banner.straight_cross.purple": "紫錯",
  "block.minecraft.banner.straight_cross.red": "赤錯",
  "block.minecraft.banner.straight_cross.white": "素錯",
  "block.minecraft.banner.straight_cross.yellow": "黃錯",
  "block.minecraft.banner.stripe_bottom.black": "玄底",
  "block.minecraft.banner.stripe_bottom.blue": "靛底",
  "block.minecraft.banner.stripe_bottom.brown": "褐底",
  "block.minecraft.banner.stripe_bottom.cyan": "黛底",
  "block.minecraft.banner.stripe_bottom.gray": "灰底",
  "block.minecraft.banner.stripe_bottom.green": "綠底",
  "block.minecraft.banner.stripe_bottom.light_blue": "縹底",
  "block.minecraft.banner.stripe_bottom.light_gray": "蒼底",
  "block.minecraft.banner.stripe_bottom.lime": "翠底",
  "block.minecraft.banner.stripe_bottom.magenta": "赬底",
  "block.minecraft.banner.stripe_bottom.orange": "橙底",
  "block.minecraft.banner.stripe_bottom.pink": "紅底",
  "block.minecraft.banner.stripe_bottom.purple": "紫底",
  "block.minecraft.banner.stripe_bottom.red": "赤底",
  "block.minecraft.banner.stripe_bottom.white": "素底",
  "block.minecraft.banner.stripe_bottom.yellow": "黃底",
  "block.minecraft.banner.stripe_center.black": "央玄縱",
  "block.minecraft.banner.stripe_center.blue": "央靛縱",
  "block.minecraft.banner.stripe_center.brown": "央褐縱",
  "block.minecraft.banner.stripe_center.cyan": "央黛縱",
  "block.minecraft.banner.stripe_center.gray": "央灰縱",
  "block.minecraft.banner.stripe_center.green": "央綠縱",
  "block.minecraft.banner.stripe_center.light_blue": "央縹縱",
  "block.minecraft.banner.stripe_center.light_gray": "央蒼縱",
  "block.minecraft.banner.stripe_center.lime": "央翠縱",
  "block.minecraft.banner.stripe_center.magenta": "央赬縱",
  "block.minecraft.banner.stripe_center.orange": "央橙縱",
  "block.minecraft.banner.stripe_center.pink": "央紅縱",
  "block.minecraft.banner.stripe_center.purple": "央紫縱",
  "block.minecraft.banner.stripe_center.red": "央赤縱",
  "block.minecraft.banner.stripe_center.white": "央素緯",
  "block.minecraft.banner.stripe_center.yellow": "央黃縱",
  "block.minecraft.banner.stripe_downleft.black": "左玄緞",
  "block.minecraft.banner.stripe_downleft.blue": "左靛緞",
  "block.minecraft.banner.stripe_downleft.brown": "左褐緞",
  "block.minecraft.banner.stripe_downleft.cyan": "左黛緞",
  "block.minecraft.banner.stripe_downleft.gray": "左灰緞",
  "block.minecraft.banner.stripe_downleft.green": "左綠緞",
  "block.minecraft.banner.stripe_downleft.light_blue": "左縹緞",
  "block.minecraft.banner.stripe_downleft.light_gray": "左蒼緞",
  "block.minecraft.banner.stripe_downleft.lime": "左翠緞",
  "block.minecraft.banner.stripe_downleft.magenta": "左赬緞",
  "block.minecraft.banner.stripe_downleft.orange": "左橙緞",
  "block.minecraft.banner.stripe_downleft.pink": "左紅緞",
  "block.minecraft.banner.stripe_downleft.purple": "左紫緞",
  "block.minecraft.banner.stripe_downleft.red": "左赤緞",
  "block.minecraft.banner.stripe_downleft.white": "左素緞",
  "block.minecraft.banner.stripe_downleft.yellow": "左黃緞",
  "block.minecraft.banner.stripe_downright.black": "右玄緞",
  "block.minecraft.banner.stripe_downright.blue": "右靛緞",
  "block.minecraft.banner.stripe_downright.brown": "右褐緞",
  "block.minecraft.banner.stripe_downright.cyan": "右黛緞",
  "block.minecraft.banner.stripe_downright.gray": "右灰緞",
  "block.minecraft.banner.stripe_downright.green": "右綠緞",
  "block.minecraft.banner.stripe_downright.light_blue": "右縹緞",
  "block.minecraft.banner.stripe_downright.light_gray": "右蒼緞",
  "block.minecraft.banner.stripe_downright.lime": "右翠緞",
  "block.minecraft.banner.stripe_downright.magenta": "右赬緞",
  "block.minecraft.banner.stripe_downright.orange": "右橙緞",
  "block.minecraft.banner.stripe_downright.pink": "右紅緞",
  "block.minecraft.banner.stripe_downright.purple": "右紫緞",
  "block.minecraft.banner.stripe_downright.red": "右赤緞",
  "block.minecraft.banner.stripe_downright.white": "右素緞",
  "block.minecraft.banner.stripe_downright.yellow": "右黃緞",
  "block.minecraft.banner.stripe_left.black": "右玄",
  "block.minecraft.banner.stripe_left.blue": "右靛",
  "block.minecraft.banner.stripe_left.brown": "右褐",
  "block.minecraft.banner.stripe_left.cyan": "右黛",
  "block.minecraft.banner.stripe_left.gray": "右灰",
  "block.minecraft.banner.stripe_left.green": "右綠",
  "block.minecraft.banner.stripe_left.light_blue": "右縹",
  "block.minecraft.banner.stripe_left.light_gray": "右蒼",
  "block.minecraft.banner.stripe_left.lime": "右翠",
  "block.minecraft.banner.stripe_left.magenta": "右赬",
  "block.minecraft.banner.stripe_left.orange": "右橙",
  "block.minecraft.banner.stripe_left.pink": "右紅",
  "block.minecraft.banner.stripe_left.purple": "右紫",
  "block.minecraft.banner.stripe_left.red": "右赤",
  "block.minecraft.banner.stripe_left.white": "右素",
  "block.minecraft.banner.stripe_left.yellow": "右黃",
  "block.minecraft.banner.stripe_middle.black": "央玄緯",
  "block.minecraft.banner.stripe_middle.blue": "央靛緯",
  "block.minecraft.banner.stripe_middle.brown": "央褐緯",
  "block.minecraft.banner.stripe_middle.cyan": "央黛緯",
  "block.minecraft.banner.stripe_middle.gray": "央灰緯",
  "block.minecraft.banner.stripe_middle.green": "央綠緯",
  "block.minecraft.banner.stripe_middle.light_blue": "央縹緯",
  "block.minecraft.banner.stripe_middle.light_gray": "央蒼緯",
  "block.minecraft.banner.stripe_middle.lime": "央翠緯",
  "block.minecraft.banner.stripe_middle.magenta": "央赬緯",
  "block.minecraft.banner.stripe_middle.orange": "央橙緯",
  "block.minecraft.banner.stripe_middle.pink": "央紅緯",
  "block.minecraft.banner.stripe_middle.purple": "央紫緯",
  "block.minecraft.banner.stripe_middle.red": "央赤緯",
  "block.minecraft.banner.stripe_middle.white": "中素橫條",
  "block.minecraft.banner.stripe_middle.yellow": "央黃緯",
  "block.minecraft.banner.stripe_right.black": "左玄",
  "block.minecraft.banner.stripe_right.blue": "左靛",
  "block.minecraft.banner.stripe_right.brown": "左褐",
  "block.minecraft.banner.stripe_right.cyan": "左黛",
  "block.minecraft.banner.stripe_right.gray": "左灰",
  "block.minecraft.banner.stripe_right.green": "左綠",
  "block.minecraft.banner.stripe_right.light_blue": "左縹",
  "block.minecraft.banner.stripe_right.light_gray": "左蒼",
  "block.minecraft.banner.stripe_right.lime": "左翠",
  "block.minecraft.banner.stripe_right.magenta": "左赬",
  "block.minecraft.banner.stripe_right.orange": "左橙",
  "block.minecraft.banner.stripe_right.pink": "左紅",
  "block.minecraft.banner.stripe_right.purple": "左紫",
  "block.minecraft.banner.stripe_right.red": "左赤",
  "block.minecraft.banner.stripe_right.white": "左素",
  "block.minecraft.banner.stripe_right.yellow": "左黃",
  "block.minecraft.banner.stripe_top.black": "玄頂",
  "block.minecraft.banner.stripe_top.blue": "靛頂",
  "block.minecraft.banner.stripe_top.brown": "褐頂",
  "block.minecraft.banner.stripe_top.cyan": "黛頂",
  "block.minecraft.banner.stripe_top.gray": "灰頂",
  "block.minecraft.banner.stripe_top.green": "綠頂",
  "block.minecraft.banner.stripe_top.light_blue": "縹頂",
  "block.minecraft.banner.stripe_top.light_gray": "蒼頂",
  "block.minecraft.banner.stripe_top.lime": "翠頂",
  "block.minecraft.banner.stripe_top.magenta": "赬頂",
  "block.minecraft.banner.stripe_top.orange": "橙頂",
  "block.minecraft.banner.stripe_top.pink": "紅頂",
  "block.minecraft.banner.stripe_top.purple": "紫頂",
  "block.minecraft.banner.stripe_top.red": "赤頂",
  "block.minecraft.banner.stripe_top.white": "素頂",
  "block.minecraft.banner.stripe_top.yellow": "黃頂",
  "block.minecraft.banner.triangle_bottom.black": "底玄勾股紋",
  "block.minecraft.banner.triangle_bottom.blue": "底靛勾股紋",
  "block.minecraft.banner.triangle_bottom.brown": "底褐勾股紋",
  "block.minecraft.banner.triangle_bottom.cyan": "底黛勾股紋",
  "block.minecraft.banner.triangle_bottom.gray": "底灰勾股紋",
  "block.minecraft.banner.triangle_bottom.green": "底綠勾股紋",
  "block.minecraft.banner.triangle_bottom.light_blue": "底縹勾股紋",
  "block.minecraft.banner.triangle_bottom.light_gray": "底蒼勾股紋",
  "block.minecraft.banner.triangle_bottom.lime": "底翠勾股紋",
  "block.minecraft.banner.triangle_bottom.magenta": "底赬勾股紋",
  "block.minecraft.banner.triangle_bottom.orange": "底橙勾股紋",
  "block.minecraft.banner.triangle_bottom.pink": "底紅勾股紋",
  "block.minecraft.banner.triangle_bottom.purple": "底紫勾股紋",
  "block.minecraft.banner.triangle_bottom.red": "底赤勾股紋",
  "block.minecraft.banner.triangle_bottom.white": "底素勾股紋",
  "block.minecraft.banner.triangle_bottom.yellow": "底黃勾股紋",
  "block.minecraft.banner.triangle_top.black": "頂玄反勾股紋",
  "block.minecraft.banner.triangle_top.blue": "頂靛反勾股紋",
  "block.minecraft.banner.triangle_top.brown": "頂褐反勾股紋",
  "block.minecraft.banner.triangle_top.cyan": "頂黛反勾股紋",
  "block.minecraft.banner.triangle_top.gray": "頂灰反勾股紋",
  "block.minecraft.banner.triangle_top.green": "頂綠反勾股紋",
  "block.minecraft.banner.triangle_top.light_blue": "頂縹反勾股紋",
  "block.minecraft.banner.triangle_top.light_gray": "頂蒼反勾股紋",
  "block.minecraft.banner.triangle_top.lime": "頂翠反勾股紋",
  "block.minecraft.banner.triangle_top.magenta": "頂赬反勾股紋",
  "block.minecraft.banner.triangle_top.orange": "頂橙反勾股紋",
  "block.minecraft.banner.triangle_top.pink": "頂紅反勾股紋",
  "block.minecraft.banner.triangle_top.purple": "頂紫反勾股紋",
  "block.minecraft.banner.triangle_top.red": "頂赤反勾股紋",
  "block.minecraft.banner.triangle_top.white": "頂素反勾股紋",
  "block.minecraft.banner.triangle_top.yellow": "頂黃反勾股紋",
  "block.minecraft.banner.triangles_bottom.black": "底玄齒紋",
  "block.minecraft.banner.triangles_bottom.blue": "底靛齒紋",
  "block.minecraft.banner.triangles_bottom.brown": "底褐齒紋",
  "block.minecraft.banner.triangles_bottom.cyan": "底黛齒紋",
  "block.minecraft.banner.triangles_bottom.gray": "底灰齒紋",
  "block.minecraft.banner.triangles_bottom.green": "底綠齒紋",
  "block.minecraft.banner.triangles_bottom.light_blue": "底縹齒紋",
  "block.minecraft.banner.triangles_bottom.light_gray": "底蒼齒紋",
  "block.minecraft.banner.triangles_bottom.lime": "底翠齒紋",
  "block.minecraft.banner.triangles_bottom.magenta": "底赬齒紋",
  "block.minecraft.banner.triangles_bottom.orange": "底橙齒紋",
  "block.minecraft.banner.triangles_bottom.pink": "底紅齒紋",
  "block.minecraft.banner.triangles_bottom.purple": "底紫齒紋",
  "block.minecraft.banner.triangles_bottom.red": "底赤齒紋",
  "block.minecraft.banner.triangles_bottom.white": "底素齒紋",
  "block.minecraft.banner.triangles_bottom.yellow": "底黃齒紋",
  "block.minecraft.banner.triangles_top.black": "頂玄齒紋",
  "block.minecraft.banner.triangles_top.blue": "頂靛齒紋",
  "block.minecraft.banner.triangles_top.brown": "頂褐齒紋",
  "block.minecraft.banner.triangles_top.cyan": "頂黛齒紋",
  "block.minecraft.banner.triangles_top.gray": "頂灰齒紋",
  "block.minecraft.banner.triangles_top.green": "頂綠齒紋",
  "block.minecraft.banner.triangles_top.light_blue": "頂縹齒紋",
  "block.minecraft.banner.triangles_top.light_gray": "頂蒼齒紋",
  "block.minecraft.banner.triangles_top.lime": "頂翠齒紋",
  "block.minecraft.banner.triangles_top.magenta": "頂赬齒紋",
  "block.minecraft.banner.triangles_top.orange": "頂橙齒紋",
  "block.minecraft.banner.triangles_top.pink": "頂紅齒紋",
  "block.minecraft.banner.triangles_top.purple": "頂紫齒紋",
  "block.minecraft.banner.triangles_top.red": "頂赤齒紋",
  "block.minecraft.banner.triangles_top.white": "頂素齒紋",
  "block.minecraft.banner.triangles_top.yellow": "頂黃齒紋",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.barrier": "障",
  "block.minecraft.basalt": "黑堦石",
  "block.minecraft.beacon": "烽火臺",
  "block.minecraft.beacon.primary": "主效",
  "block.minecraft.beacon.secondary": "副效",
  "block.minecraft.bed.no_sleep": "汝唯可寢於夜抑雷雨之時",
  "block.minecraft.bed.not_safe": "怪邇而不可寢",
  "block.minecraft.bed.obstructed": "是床見阻",
  "block.minecraft.bed.occupied": "是床見佔",
  "block.minecraft.bed.too_far_away": "床遠而不可寢",
  "block.minecraft.bedrock": "基石",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "block.minecraft.beetroots": "甘藜根",
  "block.minecraft.bell": "鐘",
  "block.minecraft.big_dripleaf": "碩垂滴葉",
  "block.minecraft.big_dripleaf_stem": "碩垂滴葉莖",
  "block.minecraft.birch_button": "樺鈕",
  "block.minecraft.birch_door": "樺門",
  "block.minecraft.birch_fence": "樺檻",
  "block.minecraft.birch_fence_gate": "樺扉",
  "block.minecraft.birch_hanging_sign": "樺懸牌",
  "block.minecraft.birch_leaves": "樺葉",
  "block.minecraft.birch_log": "樺樁",
  "block.minecraft.birch_planks": "樺材",
  "block.minecraft.birch_pressure_plate": "樺踏板",
  "block.minecraft.birch_sapling": "樺秧",
  "block.minecraft.birch_shelf": "樺櫥",
  "block.minecraft.birch_sign": "樺牌",
  "block.minecraft.birch_slab": "樺版",
  "block.minecraft.birch_stairs": "樺階",
  "block.minecraft.birch_trapdoor": "樺窖門",
  "block.minecraft.birch_wall_hanging_sign": "壁中樺懸牌",
  "block.minecraft.birch_wall_sign": "壁中樺牌",
  "block.minecraft.birch_wood": "樺木",
  "block.minecraft.black_banner": "玄旗",
  "block.minecraft.black_bed": "黑床",
  "block.minecraft.black_candle": "黑燭",
  "block.minecraft.black_candle_cake": "黑燭之洋糕",
  "block.minecraft.black_carpet": "黑氍毹",
  "block.minecraft.black_concrete": "黑砼",
  "block.minecraft.black_concrete_powder": "黑砼粉",
  "block.minecraft.black_glazed_terracotta": "黑釉陶",
  "block.minecraft.black_shulker_box": "黑贆櫝",
  "block.minecraft.black_stained_glass": "黑琉璃",
  "block.minecraft.black_stained_glass_pane": "黑琉璃嵌板",
  "block.minecraft.black_terracotta": "黑陶",
  "block.minecraft.black_wool": "黑羊毛",
  "block.minecraft.blackstone": "墨石",
  "block.minecraft.blackstone_slab": "墨石版",
  "block.minecraft.blackstone_stairs": "墨石階",
  "block.minecraft.blackstone_wall": "墨石垣",
  "block.minecraft.blast_furnace": "冶爐",
  "block.minecraft.blue_banner": "靛旗",
  "block.minecraft.blue_bed": "靛床",
  "block.minecraft.blue_candle": "靛燭",
  "block.minecraft.blue_candle_cake": "靛燭之洋糕",
  "block.minecraft.blue_carpet": "靛氍毹",
  "block.minecraft.blue_concrete": "靛砼",
  "block.minecraft.blue_concrete_powder": "靛砼粉",
  "block.minecraft.blue_glazed_terracotta": "靛釉陶",
  "block.minecraft.blue_ice": "靛冰",
  "block.minecraft.blue_orchid": "蘭",
  "block.minecraft.blue_shulker_box": "靛贆櫝",
  "block.minecraft.blue_stained_glass": "靛琉璃",
  "block.minecraft.blue_stained_glass_pane": "靛琉璃嵌板",
  "block.minecraft.blue_terracotta": "靛陶",
  "block.minecraft.blue_wool": "靛羊毛",
  "block.minecraft.bone_block": "骨塊",
  "block.minecraft.bookshelf": "書櫥",
  "block.minecraft.brain_coral": "腦珊瑚",
  "block.minecraft.brain_coral_block": "腦珊瑚塊",
  "block.minecraft.brain_coral_fan": "扇狀腦珊瑚",
  "block.minecraft.brain_coral_wall_fan": "壁中扇狀腦珊瑚",
  "block.minecraft.brewing_stand": "煉藥臺",
  "block.minecraft.brick_slab": "磚版",
  "block.minecraft.brick_stairs": "磚階",
  "block.minecraft.brick_wall": "磚垣",
  "block.minecraft.bricks": "磚塊",
  "block.minecraft.brown_banner": "褐旗",
  "block.minecraft.brown_bed": "褐床",
  "block.minecraft.brown_candle": "褐燭",
  "block.minecraft.brown_candle_cake": "褐燭之洋糕",
  "block.minecraft.brown_carpet": "褐氍毹",
  "block.minecraft.brown_concrete": "褐砼",
  "block.minecraft.brown_concrete_powder": "褐砼粉",
  "block.minecraft.brown_glazed_terracotta": "褐釉陶",
  "block.minecraft.brown_mushroom": "褐蕈",
  "block.minecraft.brown_mushroom_block": "褐蕈塊",
  "block.minecraft.brown_shulker_box": "褐贆櫝",
  "block.minecraft.brown_stained_glass": "褐琉璃",
  "block.minecraft.brown_stained_glass_pane": "褐琉璃嵌板",
  "block.minecraft.brown_terracotta": "褐陶",
  "block.minecraft.brown_wool": "褐羊毛",
  "block.minecraft.bubble_column": "氣柱",
  "block.minecraft.bubble_coral": "泡珊瑚",
  "block.minecraft.bubble_coral_block": "泡珊瑚塊",
  "block.minecraft.bubble_coral_fan": "扇狀泡珊瑚",
  "block.minecraft.bubble_coral_wall_fan": "壁中扇狀泡珊瑚",
  "block.minecraft.budding_amethyst": "蘊芽紫水玉",
  "block.minecraft.bush": "叢",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.cactus_flower": "仙人掌花",
  "block.minecraft.cake": "洋糕",
  "block.minecraft.calcite": "滑方石",
  "block.minecraft.calibrated_sculk_sensor": "幽匿校探子",
  "block.minecraft.campfire": "營火",
  "block.minecraft.candle": "燭",
  "block.minecraft.candle_cake": "有燭之洋糕",
  "block.minecraft.carrots": "胡蘆菔",
  "block.minecraft.cartography_table": "輿圖案",
  "block.minecraft.carved_pumpkin": "雕南瓜",
  "block.minecraft.cauldron": "釜",
  "block.minecraft.cave_air": "穴氣",
  "block.minecraft.cave_vines": "穴藤",
  "block.minecraft.cave_vines_plant": "穴藤株",
  "block.minecraft.chain": "鏈",
  "block.minecraft.chain_command_block": "連鎖命令塊",
  "block.minecraft.cherry_button": "櫻鈕",
  "block.minecraft.cherry_door": "櫻門",
  "block.minecraft.cherry_fence": "櫻檻",
  "block.minecraft.cherry_fence_gate": "櫻扉",
  "block.minecraft.cherry_hanging_sign": "櫻懸牌",
  "block.minecraft.cherry_leaves": "櫻葉",
  "block.minecraft.cherry_log": "櫻樁",
  "block.minecraft.cherry_planks": "櫻材",
  "block.minecraft.cherry_pressure_plate": "櫻踏板",
  "block.minecraft.cherry_sapling": "櫻秧",
  "block.minecraft.cherry_shelf": "櫻櫥",
  "block.minecraft.cherry_sign": "櫻牌",
  "block.minecraft.cherry_slab": "櫻版",
  "block.minecraft.cherry_stairs": "櫻階",
  "block.minecraft.cherry_trapdoor": "櫻窖門",
  "block.minecraft.cherry_wall_hanging_sign": "壁中櫻懸牌",
  "block.minecraft.cherry_wall_sign": "壁中櫻牌",
  "block.minecraft.cherry_wood": "櫻木",
  "block.minecraft.chest": "箱",
  "block.minecraft.chipped_anvil": "裂鐵砧",
  "block.minecraft.chiseled_bookshelf": "雕書櫥",
  "block.minecraft.chiseled_copper": "雕銅塊",
  "block.minecraft.chiseled_deepslate": "雕板石",
  "block.minecraft.chiseled_nether_bricks": "雕焱界磚",
  "block.minecraft.chiseled_polished_blackstone": "雕鎣墨石",
  "block.minecraft.chiseled_quartz_block": "雕石英塊",
  "block.minecraft.chiseled_red_sandstone": "雕赤砂",
  "block.minecraft.chiseled_resin_bricks": "雕樹香磚",
  "block.minecraft.chiseled_sandstone": "雕砂",
  "block.minecraft.chiseled_stone_bricks": "雕磚",
  "block.minecraft.chiseled_tuff": "雕積塊石",
  "block.minecraft.chiseled_tuff_bricks": "雕積塊石磚",
  "block.minecraft.chorus_flower": "頌緲花",
  "block.minecraft.chorus_plant": "頌緲枝",
  "block.minecraft.clay": "埴塊",
  "block.minecraft.closed_eyeblossom": "瞑瞳榮",
  "block.minecraft.coal_block": "石炭塊",
  "block.minecraft.coal_ore": "石炭礦",
  "block.minecraft.coarse_dirt": "澱土",
  "block.minecraft.cobbled_deepslate": "碎板石",
  "block.minecraft.cobbled_deepslate_slab": "碎板石版",
  "block.minecraft.cobbled_deepslate_stairs": "碎板石階",
  "block.minecraft.cobbled_deepslate_wall": "碎板石垣",
  "block.minecraft.cobblestone": "䃮",
  "block.minecraft.cobblestone_slab": "䃮版",
  "block.minecraft.cobblestone_stairs": "䃮階",
  "block.minecraft.cobblestone_wall": "䃮垣",
  "block.minecraft.cobweb": "蛛網",
  "block.minecraft.cocoa": "可可荳",
  "block.minecraft.command_block": "命令塊",
  "block.minecraft.comparator": "較赭儀",
  "block.minecraft.composter": "肥箱",
  "block.minecraft.conduit": "湧靈核",
  "block.minecraft.copper_bars": "銅檻",
  "block.minecraft.copper_block": "銅塊",
  "block.minecraft.copper_bulb": "銅燈",
  "block.minecraft.copper_chain": "銅鏈",
  "block.minecraft.copper_chest": "銅箱",
  "block.minecraft.copper_door": "銅門",
  "block.minecraft.copper_golem_statue": "銅傀儡俑",
  "block.minecraft.copper_grate": "銅柵網",
  "block.minecraft.copper_lantern": "銅燈籠",
  "block.minecraft.copper_ore": "銅礦",
  "block.minecraft.copper_torch": "銅炬",
  "block.minecraft.copper_trapdoor": "銅窖門",
  "block.minecraft.copper_wall_torch": "壁中銅炬",
  "block.minecraft.cornflower": "矢車菊",
  "block.minecraft.cracked_deepslate_bricks": "裂板石磚",
  "block.minecraft.cracked_deepslate_tiles": "裂板石瓦",
  "block.minecraft.cracked_nether_bricks": "裂焱界磚",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂鎣墨石磚",
  "block.minecraft.cracked_stone_bricks": "裂磚",
  "block.minecraft.crafter": "製械",
  "block.minecraft.crafting_table": "製物案",
  "block.minecraft.creaking_heart": "䦪心",
  "block.minecraft.creeper_head": "伏臨首",
  "block.minecraft.creeper_wall_head": "壁中伏臨首",
  "block.minecraft.crimson_button": "緋蕈木鈕",
  "block.minecraft.crimson_door": "緋蕈木門",
  "block.minecraft.crimson_fence": "緋蕈木檻",
  "block.minecraft.crimson_fence_gate": "緋蕈木扉",
  "block.minecraft.crimson_fungus": "緋蕈",
  "block.minecraft.crimson_hanging_sign": "緋蕈木懸牌",
  "block.minecraft.crimson_hyphae": "緋蕈體",
  "block.minecraft.crimson_nylium": "緋蕈石",
  "block.minecraft.crimson_planks": "緋蕈木材",
  "block.minecraft.crimson_pressure_plate": "緋蕈木踏板",
  "block.minecraft.crimson_roots": "緋蕈索",
  "block.minecraft.crimson_shelf": "緋蕈櫥",
  "block.minecraft.crimson_sign": "緋蕈木牌",
  "block.minecraft.crimson_slab": "緋蕈木版",
  "block.minecraft.crimson_stairs": "緋蕈木階",
  "block.minecraft.crimson_stem": "緋蕈柄",
  "block.minecraft.crimson_trapdoor": "緋蕈木窖門",
  "block.minecraft.crimson_wall_hanging_sign": "壁中緋蕈木懸牌",
  "block.minecraft.crimson_wall_sign": "壁中緋蕈木牌",
  "block.minecraft.crying_obsidian": "泣黑曜石",
  "block.minecraft.cut_copper": "割銅塊",
  "block.minecraft.cut_copper_slab": "割銅版",
  "block.minecraft.cut_copper_stairs": "割銅階",
  "block.minecraft.cut_red_sandstone": "割赤砂",
  "block.minecraft.cut_red_sandstone_slab": "割赤砂版",
  "block.minecraft.cut_sandstone": "割砂",
  "block.minecraft.cut_sandstone_slab": "割砂版",
  "block.minecraft.cyan_banner": "黛旗",
  "block.minecraft.cyan_bed": "黛床",
  "block.minecraft.cyan_candle": "黛燭",
  "block.minecraft.cyan_candle_cake": "黛燭之洋糕",
  "block.minecraft.cyan_carpet": "黛氍毹",
  "block.minecraft.cyan_concrete": "黛砼",
  "block.minecraft.cyan_concrete_powder": "黛砼粉",
  "block.minecraft.cyan_glazed_terracotta": "黛釉陶",
  "block.minecraft.cyan_shulker_box": "黛贆櫝",
  "block.minecraft.cyan_stained_glass": "黛琉璃",
  "block.minecraft.cyan_stained_glass_pane": "黛琉璃嵌板",
  "block.minecraft.cyan_terracotta": "黛陶",
  "block.minecraft.cyan_wool": "黛羊毛",
  "block.minecraft.damaged_anvil": "壞鐵砧",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.dark_oak_button": "黯柞鈕",
  "block.minecraft.dark_oak_door": "黯柞門",
  "block.minecraft.dark_oak_fence": "黯柞檻",
  "block.minecraft.dark_oak_fence_gate": "黯柞扉",
  "block.minecraft.dark_oak_hanging_sign": "黯柞懸牌",
  "block.minecraft.dark_oak_leaves": "黯柞葉",
  "block.minecraft.dark_oak_log": "黯柞樁",
  "block.minecraft.dark_oak_planks": "黯柞材",
  "block.minecraft.dark_oak_pressure_plate": "黯柞踏板",
  "block.minecraft.dark_oak_sapling": "黯柞秧",
  "block.minecraft.dark_oak_shelf": "黯柞櫥",
  "block.minecraft.dark_oak_sign": "黯柞牌",
  "block.minecraft.dark_oak_slab": "黯柞版",
  "block.minecraft.dark_oak_stairs": "黯柞階",
  "block.minecraft.dark_oak_trapdoor": "黯柞窖門",
  "block.minecraft.dark_oak_wall_hanging_sign": "壁中黯柞懸牌",
  "block.minecraft.dark_oak_wall_sign": "壁中黯柞牌",
  "block.minecraft.dark_oak_wood": "黯柞木",
  "block.minecraft.dark_prismarine": "黯海磷",
  "block.minecraft.dark_prismarine_slab": "黯海磷版",
  "block.minecraft.dark_prismarine_stairs": "黯海磷階",
  "block.minecraft.daylight_detector": "測暉儀",
  "block.minecraft.dead_brain_coral": "枯腦珊瑚",
  "block.minecraft.dead_brain_coral_block": "枯腦珊瑚塊",
  "block.minecraft.dead_brain_coral_fan": "枯扇狀腦珊瑚",
  "block.minecraft.dead_brain_coral_wall_fan": "壁中枯扇狀腦珊瑚",
  "block.minecraft.dead_bubble_coral": "枯泡珊瑚",
  "block.minecraft.dead_bubble_coral_block": "枯泡珊瑚塊",
  "block.minecraft.dead_bubble_coral_fan": "枯扇狀泡珊瑚",
  "block.minecraft.dead_bubble_coral_wall_fan": "壁中枯扇狀泡珊瑚",
  "block.minecraft.dead_bush": "枯木",
  "block.minecraft.dead_fire_coral": "枯火珊瑚",
  "block.minecraft.dead_fire_coral_block": "枯火珊瑚塊",
  "block.minecraft.dead_fire_coral_fan": "枯扇狀火珊瑚",
  "block.minecraft.dead_fire_coral_wall_fan": "壁中枯扇狀火珊瑚",
  "block.minecraft.dead_horn_coral": "枯角珊瑚",
  "block.minecraft.dead_horn_coral_block": "枯角珊瑚塊",
  "block.minecraft.dead_horn_coral_fan": "枯扇狀角珊瑚",
  "block.minecraft.dead_horn_coral_wall_fan": "壁中枯扇狀角珊瑚",
  "block.minecraft.dead_tube_coral": "枯管珊瑚",
  "block.minecraft.dead_tube_coral_block": "枯管珊瑚塊",
  "block.minecraft.dead_tube_coral_fan": "枯扇狀管珊瑚",
  "block.minecraft.dead_tube_coral_wall_fan": "壁中枯扇狀管珊瑚",
  "block.minecraft.decorated_pot": "飾甕",
  "block.minecraft.deepslate": "板石",
  "block.minecraft.deepslate_brick_slab": "板石磚版",
  "block.minecraft.deepslate_brick_stairs": "板石磚階",
  "block.minecraft.deepslate_brick_wall": "板石磚垣",
  "block.minecraft.deepslate_bricks": "板石磚",
  "block.minecraft.deepslate_coal_ore": "深石炭礦",
  "block.minecraft.deepslate_copper_ore": "深銅礦",
  "block.minecraft.deepslate_diamond_ore": "深金剛石礦",
  "block.minecraft.deepslate_emerald_ore": "深祖母綠礦",
  "block.minecraft.deepslate_gold_ore": "深金礦",
  "block.minecraft.deepslate_iron_ore": "深鐵礦",
  "block.minecraft.deepslate_lapis_ore": "深群青礦",
  "block.minecraft.deepslate_redstone_ore": "深赤石礦",
  "block.minecraft.deepslate_tile_slab": "板石瓦版",
  "block.minecraft.deepslate_tile_stairs": "板石瓦階",
  "block.minecraft.deepslate_tile_wall": "板石瓦垣",
  "block.minecraft.deepslate_tiles": "板石瓦",
  "block.minecraft.detector_rail": "測軌",
  "block.minecraft.diamond_block": "金剛石塊",
  "block.minecraft.diamond_ore": "金剛石礦",
  "block.minecraft.diorite": "閃綠石",
  "block.minecraft.diorite_slab": "閃綠石版",
  "block.minecraft.diorite_stairs": "閃綠石階",
  "block.minecraft.diorite_wall": "閃綠石垣",
  "block.minecraft.dirt": "土",
  "block.minecraft.dirt_path": "土徑",
  "block.minecraft.dispenser": "射械",
  "block.minecraft.dragon_egg": "龍卵",
  "block.minecraft.dragon_head": "龍首",
  "block.minecraft.dragon_wall_head": "壁中龍首",
  "block.minecraft.dried_ghast": "乾魄",
  "block.minecraft.dried_kelp_block": "乾海帶塊",
  "block.minecraft.dripstone_block": "鐘乳石塊",
  "block.minecraft.dropper": "擲械",
  "block.minecraft.emerald_block": "祖母綠塊",
  "block.minecraft.emerald_ore": "祖母綠礦",
  "block.minecraft.enchanting_table": "淬靈案",
  "block.minecraft.end_gateway": "終界門關",
  "block.minecraft.end_portal": "終界結界門",
  "block.minecraft.end_portal_frame": "終界結界門匡",
  "block.minecraft.end_rod": "終界燭",
  "block.minecraft.end_stone": "終界石",
  "block.minecraft.end_stone_brick_slab": "終界石磚版",
  "block.minecraft.end_stone_brick_stairs": "終界石磚階",
  "block.minecraft.end_stone_brick_wall": "終界石磚垣",
  "block.minecraft.end_stone_bricks": "終界石磚",
  "block.minecraft.ender_chest": "終眇箱",
  "block.minecraft.exposed_chiseled_copper": "渡濕雕銅塊",
  "block.minecraft.exposed_copper": "渡濕銅塊",
  "block.minecraft.exposed_copper_bars": "渡濕銅檻",
  "block.minecraft.exposed_copper_bulb": "渡濕銅燈",
  "block.minecraft.exposed_copper_chain": "渡濕銅鏈",
  "block.minecraft.exposed_copper_chest": "渡濕銅箱",
  "block.minecraft.exposed_copper_door": "渡濕銅門",
  "block.minecraft.exposed_copper_golem_statue": "渡濕銅傀儡俑",
  "block.minecraft.exposed_copper_grate": "渡濕銅柵網",
  "block.minecraft.exposed_copper_lantern": "渡濕銅燈籠",
  "block.minecraft.exposed_copper_trapdoor": "渡濕銅窖門",
  "block.minecraft.exposed_cut_copper": "渡濕割銅塊",
  "block.minecraft.exposed_cut_copper_slab": "渡濕割銅版",
  "block.minecraft.exposed_cut_copper_stairs": "渡濕割銅階",
  "block.minecraft.exposed_lightning_rod": "渡濕引雷桿",
  "block.minecraft.farmland": "疇",
  "block.minecraft.fern": "蕨",
  "block.minecraft.fire": "火",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.fire_coral_block": "火珊瑚塊",
  "block.minecraft.fire_coral_fan": "扇狀火珊瑚",
  "block.minecraft.fire_coral_wall_fan": "壁中扇狀火珊瑚",
  "block.minecraft.firefly_bush": "螢叢",
  "block.minecraft.fletching_table": "製箭案",
  "block.minecraft.flower_pot": "盆",
  "block.minecraft.flowering_azalea": "芳杜鵑",
  "block.minecraft.flowering_azalea_leaves": "芳杜鵑葉",
  "block.minecraft.frogspawn": "鼃子",
  "block.minecraft.frosted_ice": "霜冰",
  "block.minecraft.furnace": "爐",
  "block.minecraft.gilded_blackstone": "嵌金之墨石",
  "block.minecraft.glass": "琉璃",
  "block.minecraft.glass_pane": "琉璃嵌板",
  "block.minecraft.glow_lichen": "地踏爍菰",
  "block.minecraft.glowstone": "硄",
  "block.minecraft.gold_block": "金塊",
  "block.minecraft.gold_ore": "金礦",
  "block.minecraft.golden_dandelion": "金蒲公英",
  "block.minecraft.granite": "花崗石",
  "block.minecraft.granite_slab": "花崗石版",
  "block.minecraft.granite_stairs": "花崗石階",
  "block.minecraft.granite_wall": "花崗石垣",
  "block.minecraft.grass": "艸",
  "block.minecraft.grass_block": "艸方",
  "block.minecraft.gravel": "礫",
  "block.minecraft.gray_banner": "灰旗",
  "block.minecraft.gray_bed": "灰床",
  "block.minecraft.gray_candle": "灰燭",
  "block.minecraft.gray_candle_cake": "灰燭之洋糕",
  "block.minecraft.gray_carpet": "灰氍毹",
  "block.minecraft.gray_concrete": "灰砼",
  "block.minecraft.gray_concrete_powder": "灰砼粉",
  "block.minecraft.gray_glazed_terracotta": "灰釉陶",
  "block.minecraft.gray_shulker_box": "灰贆櫝",
  "block.minecraft.gray_stained_glass": "灰琉璃",
  "block.minecraft.gray_stained_glass_pane": "灰琉璃嵌板",
  "block.minecraft.gray_terracotta": "灰陶",
  "block.minecraft.gray_wool": "灰羊毛",
  "block.minecraft.green_banner": "綠旗",
  "block.minecraft.green_bed": "綠床",
  "block.minecraft.green_candle": "綠燭",
  "block.minecraft.green_candle_cake": "綠燭之洋糕",
  "block.minecraft.green_carpet": "綠氍毹",
  "block.minecraft.green_concrete": "綠砼",
  "block.minecraft.green_concrete_powder": "綠砼粉",
  "block.minecraft.green_glazed_terracotta": "綠釉陶",
  "block.minecraft.green_shulker_box": "綠贆櫝",
  "block.minecraft.green_stained_glass": "綠琉璃",
  "block.minecraft.green_stained_glass_pane": "綠琉璃嵌板",
  "block.minecraft.green_terracotta": "綠陶",
  "block.minecraft.green_wool": "綠羊毛",
  "block.minecraft.grindstone": "礪",
  "block.minecraft.hanging_roots": "懸根",
  "block.minecraft.hay_block": "芻束",
  "block.minecraft.heavy_core": "重核",
  "block.minecraft.heavy_weighted_pressure_plate": "重踏板",
  "block.minecraft.honey_block": "蜜塊",
  "block.minecraft.honeycomb_block": "蜜脾塊",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.horn_coral": "角珊瑚",
  "block.minecraft.horn_coral_block": "角珊瑚塊",
  "block.minecraft.horn_coral_fan": "扇狀角珊瑚",
  "block.minecraft.horn_coral_wall_fan": "壁中扇狀角珊瑚",
  "block.minecraft.ice": "冰",
  "block.minecraft.infested_chiseled_stone_bricks": "蟫蝕雕磚",
  "block.minecraft.infested_cobblestone": "蟫蝕䃮",
  "block.minecraft.infested_cracked_stone_bricks": "蟫蝕裂磚",
  "block.minecraft.infested_deepslate": "蟫蝕板石",
  "block.minecraft.infested_mossy_stone_bricks": "蟫蝕苔磚",
  "block.minecraft.infested_stone": "蟫蝕石",
  "block.minecraft.infested_stone_bricks": "蟫蝕石磚",
  "block.minecraft.iron_bars": "鐵檻",
  "block.minecraft.iron_block": "鐵塊",
  "block.minecraft.iron_chain": "鐵鏈",
  "block.minecraft.iron_door": "鐵門",
  "block.minecraft.iron_ore": "鐵礦",
  "block.minecraft.iron_trapdoor": "鐵窖門",
  "block.minecraft.jack_o_lantern": "南瓜燈",
  "block.minecraft.jigsaw": "榫卯塊",
  "block.minecraft.jukebox": "留聲機",
  "block.minecraft.jungle_button": "叢莽鈕",
  "block.minecraft.jungle_door": "叢莽門",
  "block.minecraft.jungle_fence": "叢莽檻",
  "block.minecraft.jungle_fence_gate": "叢莽扉",
  "block.minecraft.jungle_hanging_sign": "叢莽懸牌",
  "block.minecraft.jungle_leaves": "叢莽葉",
  "block.minecraft.jungle_log": "叢莽樁",
  "block.minecraft.jungle_planks": "叢莽材",
  "block.minecraft.jungle_pressure_plate": "叢莽踏板",
  "block.minecraft.jungle_sapling": "叢莽秧",
  "block.minecraft.jungle_shelf": "叢莽櫥",
  "block.minecraft.jungle_sign": "叢莽牌",
  "block.minecraft.jungle_slab": "叢莽版",
  "block.minecraft.jungle_stairs": "叢莽階",
  "block.minecraft.jungle_trapdoor": "叢莽窖門",
  "block.minecraft.jungle_wall_hanging_sign": "壁中叢莽懸牌",
  "block.minecraft.jungle_wall_sign": "壁中叢莽牌",
  "block.minecraft.jungle_wood": "叢莽木",
  "block.minecraft.kelp": "海帶",
  "block.minecraft.kelp_plant": "海帶株",
  "block.minecraft.ladder": "梯",
  "block.minecraft.lantern": "燈籠",
  "block.minecraft.lapis_block": "群青塊",
  "block.minecraft.lapis_ore": "群青礦",
  "block.minecraft.large_amethyst_bud": "大紫水玉苗",
  "block.minecraft.large_fern": "大蕨",
  "block.minecraft.lava": "熔石",
  "block.minecraft.lava_cauldron": "瀦熔石之釜",
  "block.minecraft.leaf_litter": "枯葉",
  "block.minecraft.lectern": "書檯",
  "block.minecraft.lever": "閘刀",
  "block.minecraft.light": "光",
  "block.minecraft.light_blue_banner": "縹旗",
  "block.minecraft.light_blue_bed": "縹床",
  "block.minecraft.light_blue_candle": "縹燭",
  "block.minecraft.light_blue_candle_cake": "縹燭之洋糕",
  "block.minecraft.light_blue_carpet": "縹氍毹",
  "block.minecraft.light_blue_concrete": "縹砼",
  "block.minecraft.light_blue_concrete_powder": "縹砼粉",
  "block.minecraft.light_blue_glazed_terracotta": "縹釉陶",
  "block.minecraft.light_blue_shulker_box": "縹贆櫝",
  "block.minecraft.light_blue_stained_glass": "縹琉璃",
  "block.minecraft.light_blue_stained_glass_pane": "縹琉璃嵌板",
  "block.minecraft.light_blue_terracotta": "縹陶",
  "block.minecraft.light_blue_wool": "縹羊毛",
  "block.minecraft.light_gray_banner": "蒼旗",
  "block.minecraft.light_gray_bed": "蒼床",
  "block.minecraft.light_gray_candle": "蒼燭",
  "block.minecraft.light_gray_candle_cake": "蒼燭之洋糕",
  "block.minecraft.light_gray_carpet": "蒼氍毹",
  "block.minecraft.light_gray_concrete": "蒼砼",
  "block.minecraft.light_gray_concrete_powder": "蒼砼粉",
  "block.minecraft.light_gray_glazed_terracotta": "蒼釉陶",
  "block.minecraft.light_gray_shulker_box": "蒼贆櫝",
  "block.minecraft.light_gray_stained_glass": "蒼琉璃",
  "block.minecraft.light_gray_stained_glass_pane": "蒼琉璃嵌板",
  "block.minecraft.light_gray_terracotta": "蒼陶",
  "block.minecraft.light_gray_wool": "蒼羊毛",
  "block.minecraft.light_weighted_pressure_plate": "輕踏板",
  "block.minecraft.lightning_rod": "引雷桿",
  "block.minecraft.lilac": "丁香",
  "block.minecraft.lily_of_the_valley": "鈴蘭",
  "block.minecraft.lily_pad": "睡蓮",
  "block.minecraft.lime_banner": "翠旗",
  "block.minecraft.lime_bed": "翠床",
  "block.minecraft.lime_candle": "翠燭",
  "block.minecraft.lime_candle_cake": "翠燭之洋糕",
  "block.minecraft.lime_carpet": "翠氍毹",
  "block.minecraft.lime_concrete": "翠砼",
  "block.minecraft.lime_concrete_powder": "翠砼粉",
  "block.minecraft.lime_glazed_terracotta": "翠釉陶",
  "block.minecraft.lime_shulker_box": "翠贆櫝",
  "block.minecraft.lime_stained_glass": "翠琉璃",
  "block.minecraft.lime_stained_glass_pane": "翠琉璃嵌板",
  "block.minecraft.lime_terracotta": "翠陶",
  "block.minecraft.lime_wool": "翠羊毛",
  "block.minecraft.lodestone": "礠石",
  "block.minecraft.loom": "機杼",
  "block.minecraft.magenta_banner": "赬旗",
  "block.minecraft.magenta_bed": "赬床",
  "block.minecraft.magenta_candle": "赬燭",
  "block.minecraft.magenta_candle_cake": "赬燭之洋糕",
  "block.minecraft.magenta_carpet": "赬氍毹",
  "block.minecraft.magenta_concrete": "赬砼",
  "block.minecraft.magenta_concrete_powder": "赬砼粉",
  "block.minecraft.magenta_glazed_terracotta": "赬釉陶",
  "block.minecraft.magenta_shulker_box": "赬贆櫝",
  "block.minecraft.magenta_stained_glass": "赬琉璃",
  "block.minecraft.magenta_stained_glass_pane": "赬琉璃嵌板",
  "block.minecraft.magenta_terracotta": "赬陶",
  "block.minecraft.magenta_wool": "赬羊毛",
  "block.minecraft.magma_block": "火漿塊",
  "block.minecraft.mangrove_button": "沒潮木鈕",
  "block.minecraft.mangrove_door": "沒潮木門",
  "block.minecraft.mangrove_fence": "沒潮木檻",
  "block.minecraft.mangrove_fence_gate": "沒潮木扉",
  "block.minecraft.mangrove_hanging_sign": "沒潮木懸牌",
  "block.minecraft.mangrove_leaves": "沒潮木葉",
  "block.minecraft.mangrove_log": "沒潮木樁",
  "block.minecraft.mangrove_planks": "沒潮木材",
  "block.minecraft.mangrove_pressure_plate": "沒潮木踏板",
  "block.minecraft.mangrove_propagule": "沒潮木胚",
  "block.minecraft.mangrove_roots": "沒潮木根",
  "block.minecraft.mangrove_shelf": "沒潮木櫥",
  "block.minecraft.mangrove_sign": "沒潮木牌",
  "block.minecraft.mangrove_slab": "沒潮木版",
  "block.minecraft.mangrove_stairs": "沒潮木階",
  "block.minecraft.mangrove_trapdoor": "沒潮木窖門",
  "block.minecraft.mangrove_wall_hanging_sign": "壁中沒潮木懸牌",
  "block.minecraft.mangrove_wall_sign": "壁中沒潮木牌",
  "block.minecraft.mangrove_wood": "沒潮木",
  "block.minecraft.medium_amethyst_bud": "中紫水玉苗",
  "block.minecraft.melon": "寒瓜",
  "block.minecraft.melon_stem": "寒瓜莖",
  "block.minecraft.moss_block": "蘚塊",
  "block.minecraft.moss_carpet": "地蘚",
  "block.minecraft.mossy_cobblestone": "苔䃮",
  "block.minecraft.mossy_cobblestone_slab": "苔䃮版",
  "block.minecraft.mossy_cobblestone_stairs": "苔䃮階",
  "block.minecraft.mossy_cobblestone_wall": "苔䃮垣",
  "block.minecraft.mossy_stone_brick_slab": "苔磚版",
  "block.minecraft.mossy_stone_brick_stairs": "苔磚階",
  "block.minecraft.mossy_stone_brick_wall": "苔磚垣",
  "block.minecraft.mossy_stone_bricks": "苔磚",
  "block.minecraft.moving_piston": "移之鞲鞴",
  "block.minecraft.mud": "泥",
  "block.minecraft.mud_brick_slab": "泥磚版",
  "block.minecraft.mud_brick_stairs": "泥磚階",
  "block.minecraft.mud_brick_wall": "泥磚垣",
  "block.minecraft.mud_bricks": "泥磚",
  "block.minecraft.muddy_mangrove_roots": "泥沒潮木根",
  "block.minecraft.mushroom_stem": "蕈莖",
  "block.minecraft.mycelium": "盤菌土",
  "block.minecraft.nether_brick_fence": "焱界磚檻",
  "block.minecraft.nether_brick_slab": "焱界磚版",
  "block.minecraft.nether_brick_stairs": "焱界磚階",
  "block.minecraft.nether_brick_wall": "焱界磚垣",
  "block.minecraft.nether_bricks": "焱界磚塊",
  "block.minecraft.nether_gold_ore": "焱界金礦",
  "block.minecraft.nether_portal": "焱界結界門",
  "block.minecraft.nether_quartz_ore": "石英礦",
  "block.minecraft.nether_sprouts": "焱界苗",
  "block.minecraft.nether_wart": "焱界疣",
  "block.minecraft.nether_wart_block": "焱界疣塊",
  "block.minecraft.netherite_block": "玄鈺塊",
  "block.minecraft.netherrack": "焱界石",
  "block.minecraft.note_block": "絲竹匣",
  "block.minecraft.oak_button": "柞鈕",
  "block.minecraft.oak_door": "柞門",
  "block.minecraft.oak_fence": "柞檻",
  "block.minecraft.oak_fence_gate": "柞扉",
  "block.minecraft.oak_hanging_sign": "柞懸牌",
  "block.minecraft.oak_leaves": "柞葉",
  "block.minecraft.oak_log": "柞樁",
  "block.minecraft.oak_planks": "柞材",
  "block.minecraft.oak_pressure_plate": "柞踏板",
  "block.minecraft.oak_sapling": "柞秧",
  "block.minecraft.oak_shelf": "柞櫥",
  "block.minecraft.oak_sign": "柞牌",
  "block.minecraft.oak_slab": "柞版",
  "block.minecraft.oak_stairs": "柞階",
  "block.minecraft.oak_trapdoor": "柞窖門",
  "block.minecraft.oak_wall_hanging_sign": "壁中柞懸牌",
  "block.minecraft.oak_wall_sign": "壁中柞牌",
  "block.minecraft.oak_wood": "柞木",
  "block.minecraft.observer": "探械",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.ochre_froglight": "赭鼃光",
  "block.minecraft.ominous_banner": "厄軍旗麾",
  "block.minecraft.open_eyeblossom": "盱瞳榮",
  "block.minecraft.orange_banner": "橙旗",
  "block.minecraft.orange_bed": "橙床",
  "block.minecraft.orange_candle": "橙燭",
  "block.minecraft.orange_candle_cake": "橙燭之洋糕",
  "block.minecraft.orange_carpet": "橙氍毹",
  "block.minecraft.orange_concrete": "橙砼",
  "block.minecraft.orange_concrete_powder": "橙砼粉",
  "block.minecraft.orange_glazed_terracotta": "橙釉陶",
  "block.minecraft.orange_shulker_box": "橙贆櫝",
  "block.minecraft.orange_stained_glass": "橙琉璃",
  "block.minecraft.orange_stained_glass_pane": "橙琉璃嵌板",
  "block.minecraft.orange_terracotta": "橙陶",
  "block.minecraft.orange_tulip": "橙鬱金香",
  "block.minecraft.orange_wool": "橙羊毛",
  "block.minecraft.oxeye_daisy": "雛菊",
  "block.minecraft.oxidized_chiseled_copper": "風蝕雕銅塊",
  "block.minecraft.oxidized_copper": "風蝕銅塊",
  "block.minecraft.oxidized_copper_bars": "風蝕銅檻",
  "block.minecraft.oxidized_copper_bulb": "風蝕銅燈",
  "block.minecraft.oxidized_copper_chain": "風蝕銅鏈",
  "block.minecraft.oxidized_copper_chest": "風蝕銅箱",
  "block.minecraft.oxidized_copper_door": "風蝕銅門",
  "block.minecraft.oxidized_copper_golem_statue": "風蝕銅傀儡俑",
  "block.minecraft.oxidized_copper_grate": "風蝕銅柵網",
  "block.minecraft.oxidized_copper_lantern": "風蝕銅燈籠",
  "block.minecraft.oxidized_copper_trapdoor": "風蝕銅窖門",
  "block.minecraft.oxidized_cut_copper": "風蝕割銅塊",
  "block.minecraft.oxidized_cut_copper_slab": "風蝕割銅版",
  "block.minecraft.oxidized_cut_copper_stairs": "風蝕割銅階",
  "block.minecraft.oxidized_lightning_rod": "風蝕引雷桿",
  "block.minecraft.packed_ice": "夯冰",
  "block.minecraft.packed_mud": "夯泥",
  "block.minecraft.pale_hanging_moss": "縞懸蘿",
  "block.minecraft.pale_moss_block": "縞蘚塊",
  "block.minecraft.pale_moss_carpet": "縞地蘚",
  "block.minecraft.pale_oak_button": "縞柞鈕",
  "block.minecraft.pale_oak_door": "縞柞門",
  "block.minecraft.pale_oak_fence": "縞柞檻",
  "block.minecraft.pale_oak_fence_gate": "縞柞扉",
  "block.minecraft.pale_oak_hanging_sign": "縞柞懸牌",
  "block.minecraft.pale_oak_leaves": "縞柞葉",
  "block.minecraft.pale_oak_log": "縞柞樁",
  "block.minecraft.pale_oak_planks": "縞柞材",
  "block.minecraft.pale_oak_pressure_plate": "縞柞踏板",
  "block.minecraft.pale_oak_sapling": "縞柞秧",
  "block.minecraft.pale_oak_shelf": "縞柞櫥",
  "block.minecraft.pale_oak_sign": "縞柞牌",
  "block.minecraft.pale_oak_slab": "縞柞版",
  "block.minecraft.pale_oak_stairs": "縞柞階",
  "block.minecraft.pale_oak_trapdoor": "縞柞窖門",
  "block.minecraft.pale_oak_wall_hanging_sign": "壁中縞柞懸牌",
  "block.minecraft.pale_oak_wall_sign": "壁中縞柞牌",
  "block.minecraft.pale_oak_wood": "縞柞木",
  "block.minecraft.pearlescent_froglight": "玢璘鼃光",
  "block.minecraft.peony": "牡丹",
  "block.minecraft.petrified_oak_slab": "石化柞版",
  "block.minecraft.piglin_head": "豕靈首",
  "block.minecraft.piglin_wall_head": "壁中豕靈首",
  "block.minecraft.pink_banner": "紅旗",
  "block.minecraft.pink_bed": "紅床",
  "block.minecraft.pink_candle": "紅燭",
  "block.minecraft.pink_candle_cake": "紅燭之洋糕",
  "block.minecraft.pink_carpet": "紅氍毹",
  "block.minecraft.pink_concrete": "紅砼",
  "block.minecraft.pink_concrete_powder": "紅砼粉",
  "block.minecraft.pink_glazed_terracotta": "紅釉陶",
  "block.minecraft.pink_petals": "落英",
  "block.minecraft.pink_shulker_box": "紅贆櫝",
  "block.minecraft.pink_stained_glass": "紅琉璃",
  "block.minecraft.pink_stained_glass_pane": "紅琉璃嵌板",
  "block.minecraft.pink_terracotta": "紅陶",
  "block.minecraft.pink_tulip": "紅鬱金香",
  "block.minecraft.pink_wool": "紅羊毛",
  "block.minecraft.piston": "鞲鞴",
  "block.minecraft.piston_head": "鞲鞴之首",
  "block.minecraft.pitcher_crop": "小人蘭株",
  "block.minecraft.pitcher_plant": "小人蘭",
  "block.minecraft.player_head": "戲者之首",
  "block.minecraft.player_head.named": "%s之首",
  "block.minecraft.player_wall_head": "壁中戲者之首",
  "block.minecraft.podzol": "灰土",
  "block.minecraft.pointed_dripstone": "鐘乳石",
  "block.minecraft.polished_andesite": "鎣安山石",
  "block.minecraft.polished_andesite_slab": "鎣安山石版",
  "block.minecraft.polished_andesite_stairs": "鎣安山石階",
  "block.minecraft.polished_basalt": "鎣黑堦石",
  "block.minecraft.polished_blackstone": "鎣墨石",
  "block.minecraft.polished_blackstone_brick_slab": "鎣墨石磚版",
  "block.minecraft.polished_blackstone_brick_stairs": "鎣墨石磚階",
  "block.minecraft.polished_blackstone_brick_wall": "鎣墨石磚垣",
  "block.minecraft.polished_blackstone_bricks": "鎣墨石磚",
  "block.minecraft.polished_blackstone_button": "鎣墨石鈕",
  "block.minecraft.polished_blackstone_pressure_plate": "鎣墨石踏板",
  "block.minecraft.polished_blackstone_slab": "鎣墨石版",
  "block.minecraft.polished_blackstone_stairs": "鎣墨石階",
  "block.minecraft.polished_blackstone_wall": "鎣墨石垣",
  "block.minecraft.polished_deepslate": "鎣板石",
  "block.minecraft.polished_deepslate_slab": "鎣板石版",
  "block.minecraft.polished_deepslate_stairs": "鎣板石階",
  "block.minecraft.polished_deepslate_wall": "鎣板石垣",
  "block.minecraft.polished_diorite": "鎣閃綠石",
  "block.minecraft.polished_diorite_slab": "鎣閃綠石版",
  "block.minecraft.polished_diorite_stairs": "鎣閃綠石階",
  "block.minecraft.polished_granite": "鎣花崗石",
  "block.minecraft.polished_granite_slab": "鎣花崗石版",
  "block.minecraft.polished_granite_stairs": "鎣花崗石階",
  "block.minecraft.polished_tuff": "鎣積塊石",
  "block.minecraft.polished_tuff_slab": "鎣積塊石版",
  "block.minecraft.polished_tuff_stairs": "鎣積塊石階",
  "block.minecraft.polished_tuff_wall": "鎣積塊垣",
  "block.minecraft.poppy": "虞美人",
  "block.minecraft.potatoes": "洋芋",
  "block.minecraft.potted_acacia_sapling": "㭜秧盆景",
  "block.minecraft.potted_allium": "碩蔥盆景",
  "block.minecraft.potted_azalea_bush": "杜鵑盆景",
  "block.minecraft.potted_azure_bluet": "藍茜盆景",
  "block.minecraft.potted_bamboo": "竹盆景",
  "block.minecraft.potted_birch_sapling": "樺秧盆景",
  "block.minecraft.potted_blue_orchid": "蘭盆景",
  "block.minecraft.potted_brown_mushroom": "褐蕈盆景",
  "block.minecraft.potted_cactus": "仙人掌盆景",
  "block.minecraft.potted_cherry_sapling": "櫻秧盆景",
  "block.minecraft.potted_closed_eyeblossom": "瞑瞳榮盆景",
  "block.minecraft.potted_cornflower": "矢車菊盆景",
  "block.minecraft.potted_crimson_fungus": "緋蕈盆景",
  "block.minecraft.potted_crimson_roots": "緋蕈索盆景",
  "block.minecraft.potted_dandelion": "蒲公英盆景",
  "block.minecraft.potted_dark_oak_sapling": "黯柞秧盆景",
  "block.minecraft.potted_dead_bush": "枯木盆景",
  "block.minecraft.potted_fern": "蕨盆景",
  "block.minecraft.potted_flowering_azalea_bush": "芳杜鵑盆景",
  "block.minecraft.potted_golden_dandelion": "金蒲公英盆景",
  "block.minecraft.potted_jungle_sapling": "叢莽秧盆景",
  "block.minecraft.potted_lily_of_the_valley": "鈴蘭盆景",
  "block.minecraft.potted_mangrove_propagule": "沒潮木胚盆景",
  "block.minecraft.potted_oak_sapling": "柞秧盆景",
  "block.minecraft.potted_open_eyeblossom": "盱瞳榮盆景",
  "block.minecraft.potted_orange_tulip": "橙鬱金香盆景",
  "block.minecraft.potted_oxeye_daisy": "雛菊盆景",
  "block.minecraft.potted_pale_oak_sapling": "縞柞秧盆景",
  "block.minecraft.potted_pink_tulip": "紅鬱金香盆景",
  "block.minecraft.potted_poppy": "虞美人盆景",
  "block.minecraft.potted_red_mushroom": "赤蕈盆景",
  "block.minecraft.potted_red_tulip": "赤鬱金香盆景",
  "block.minecraft.potted_spruce_sapling": "樅秧盆景",
  "block.minecraft.potted_torchflower": "炬蓮盆景",
  "block.minecraft.potted_warped_fungus": "譎蕈盆景",
  "block.minecraft.potted_warped_roots": "譎蕈索盆景",
  "block.minecraft.potted_white_tulip": "白鬱金香盆景",
  "block.minecraft.potted_wither_rose": "凋靈玫瑰盆景",
  "block.minecraft.powder_snow": "齏雪",
  "block.minecraft.powder_snow_cauldron": "瀦齏雪之釜",
  "block.minecraft.powered_rail": "速軌",
  "block.minecraft.prismarine": "海磷",
  "block.minecraft.prismarine_brick_slab": "海磷磚版",
  "block.minecraft.prismarine_brick_stairs": "海磷磚階",
  "block.minecraft.prismarine_bricks": "海磷磚",
  "block.minecraft.prismarine_slab": "海磷版",
  "block.minecraft.prismarine_stairs": "海磷階",
  "block.minecraft.prismarine_wall": "海磷垣",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.pumpkin_stem": "南瓜莖",
  "block.minecraft.purple_banner": "紫旗",
  "block.minecraft.purple_bed": "紫床",
  "block.minecraft.purple_candle": "紫燭",
  "block.minecraft.purple_candle_cake": "紫燭之洋糕",
  "block.minecraft.purple_carpet": "紫氍毹",
  "block.minecraft.purple_concrete": "紫砼",
  "block.minecraft.purple_concrete_powder": "紫砼粉",
  "block.minecraft.purple_glazed_terracotta": "紫釉陶",
  "block.minecraft.purple_shulker_box": "紫贆櫝",
  "block.minecraft.purple_stained_glass": "紫琉璃",
  "block.minecraft.purple_stained_glass_pane": "紫琉璃嵌板",
  "block.minecraft.purple_terracotta": "紫陶",
  "block.minecraft.purple_wool": "紫羊毛",
  "block.minecraft.purpur_block": "紫珀塊",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_slab": "紫珀版",
  "block.minecraft.purpur_stairs": "紫珀階",
  "block.minecraft.quartz_block": "石英塊",
  "block.minecraft.quartz_bricks": "石英磚",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_slab": "石英版",
  "block.minecraft.quartz_stairs": "石英階",
  "block.minecraft.rail": "軌",
  "block.minecraft.raw_copper_block": "銅石塊",
  "block.minecraft.raw_gold_block": "金石塊",
  "block.minecraft.raw_iron_block": "鐵石塊",
  "block.minecraft.red_banner": "赤旗",
  "block.minecraft.red_bed": "赤床",
  "block.minecraft.red_candle": "赤燭",
  "block.minecraft.red_candle_cake": "赤燭之洋糕",
  "block.minecraft.red_carpet": "赤氍毹",
  "block.minecraft.red_concrete": "赤砼",
  "block.minecraft.red_concrete_powder": "赤砼粉",
  "block.minecraft.red_glazed_terracotta": "赤釉陶",
  "block.minecraft.red_mushroom": "赤蕈",
  "block.minecraft.red_mushroom_block": "赤蕈塊",
  "block.minecraft.red_nether_brick_slab": "焱界赤磚版",
  "block.minecraft.red_nether_brick_stairs": "焱界赤磚階",
  "block.minecraft.red_nether_brick_wall": "焱界赤磚垣",
  "block.minecraft.red_nether_bricks": "焱界赤磚塊",
  "block.minecraft.red_sand": "赤沙",
  "block.minecraft.red_sandstone": "赤砂",
  "block.minecraft.red_sandstone_slab": "赤砂版",
  "block.minecraft.red_sandstone_stairs": "赤砂階",
  "block.minecraft.red_sandstone_wall": "赤砂垣",
  "block.minecraft.red_shulker_box": "赤贆櫝",
  "block.minecraft.red_stained_glass": "赤琉璃",
  "block.minecraft.red_stained_glass_pane": "赤琉璃嵌板",
  "block.minecraft.red_terracotta": "赤陶",
  "block.minecraft.red_tulip": "赤鬱金香",
  "block.minecraft.red_wool": "赤羊毛",
  "block.minecraft.redstone_block": "赤石塊",
  "block.minecraft.redstone_lamp": "赤石燈",
  "block.minecraft.redstone_ore": "赤石礦",
  "block.minecraft.redstone_torch": "赤石炬",
  "block.minecraft.redstone_wall_torch": "壁中赤石炬",
  "block.minecraft.redstone_wire": "赤石綫",
  "block.minecraft.reinforced_deepslate": "固板石",
  "block.minecraft.repeater": "續赭儀",
  "block.minecraft.repeating_command_block": "循環命令塊",
  "block.minecraft.resin_block": "樹香塊",
  "block.minecraft.resin_brick_slab": "樹香磚版",
  "block.minecraft.resin_brick_stairs": "樹香磚階",
  "block.minecraft.resin_brick_wall": "樹香磚垣",
  "block.minecraft.resin_bricks": "樹香磚塊",
  "block.minecraft.resin_clump": "樹香",
  "block.minecraft.respawn_anchor": "復生錨",
  "block.minecraft.rooted_dirt": "盤根土",
  "block.minecraft.rose_bush": "玫瑰叢",
  "block.minecraft.sand": "沙",
  "block.minecraft.sandstone": "砂",
  "block.minecraft.sandstone_slab": "砂版",
  "block.minecraft.sandstone_stairs": "砂階",
  "block.minecraft.sandstone_wall": "砂垣",
  "block.minecraft.scaffolding": "棧架",
  "block.minecraft.sculk": "幽匿",
  "block.minecraft.sculk_catalyst": "幽匿引",
  "block.minecraft.sculk_sensor": "幽匿探子",
  "block.minecraft.sculk_shrieker": "幽匿嘯",
  "block.minecraft.sculk_vein": "幽匿絡",
  "block.minecraft.sea_lantern": "海磷燈",
  "block.minecraft.sea_pickle": "海鞘",
  "block.minecraft.seagrass": "海艸",
  "block.minecraft.set_spawn": "生處定也",
  "block.minecraft.short_dry_grass": "淺枯艸",
  "block.minecraft.short_grass": "淺艸",
  "block.minecraft.shroomlight": "熒蕈體",
  "block.minecraft.shulker_box": "贆櫝",
  "block.minecraft.skeleton_skull": "髑首",
  "block.minecraft.skeleton_wall_skull": "壁中髑首",
  "block.minecraft.slime_block": "黏膠塊",
  "block.minecraft.small_amethyst_bud": "小紫水玉苗",
  "block.minecraft.small_dripleaf": "幼垂滴葉",
  "block.minecraft.smithing_table": "鍛案",
  "block.minecraft.smoker": "燻爐",
  "block.minecraft.smooth_basalt": "潤黑堦石",
  "block.minecraft.smooth_quartz": "潤石英塊",
  "block.minecraft.smooth_quartz_slab": "潤石英版",
  "block.minecraft.smooth_quartz_stairs": "潤石英階",
  "block.minecraft.smooth_red_sandstone": "潤赤砂",
  "block.minecraft.smooth_red_sandstone_slab": "潤赤砂版",
  "block.minecraft.smooth_red_sandstone_stairs": "潤赤砂階",
  "block.minecraft.smooth_sandstone": "潤砂",
  "block.minecraft.smooth_sandstone_slab": "潤砂版",
  "block.minecraft.smooth_sandstone_stairs": "潤砂階",
  "block.minecraft.smooth_stone": "潤石",
  "block.minecraft.smooth_stone_slab": "潤石版",
  "block.minecraft.sniffer_egg": "嗅獸卵",
  "block.minecraft.snow": "雪",
  "block.minecraft.snow_block": "雪塊",
  "block.minecraft.soul_campfire": "靈營火",
  "block.minecraft.soul_fire": "靈火",
  "block.minecraft.soul_lantern": "靈燈",
  "block.minecraft.soul_sand": "靈沙",
  "block.minecraft.soul_soil": "靈土",
  "block.minecraft.soul_torch": "靈炬",
  "block.minecraft.soul_wall_torch": "壁中靈炬",
  "block.minecraft.spawn.not_valid": "汝無床抑得力之復生錨，或其見礙也",
  "block.minecraft.spawner": "孳衍籠",
  "block.minecraft.spawner.desc1": "用孳卵之時：",
  "block.minecraft.spawner.desc2": "設生靈之屬",
  "block.minecraft.sponge": "海綿",
  "block.minecraft.spore_blossom": "籽榮",
  "block.minecraft.spruce_button": "樅鈕",
  "block.minecraft.spruce_door": "樅門",
  "block.minecraft.spruce_fence": "樅檻",
  "block.minecraft.spruce_fence_gate": "樅扉",
  "block.minecraft.spruce_hanging_sign": "樅懸牌",
  "block.minecraft.spruce_leaves": "樅葉",
  "block.minecraft.spruce_log": "樅樁",
  "block.minecraft.spruce_planks": "樅材",
  "block.minecraft.spruce_pressure_plate": "樅踏板",
  "block.minecraft.spruce_sapling": "樅秧",
  "block.minecraft.spruce_shelf": "樅櫥",
  "block.minecraft.spruce_sign": "樅牌",
  "block.minecraft.spruce_slab": "樅版",
  "block.minecraft.spruce_stairs": "樅階",
  "block.minecraft.spruce_trapdoor": "樅窖門",
  "block.minecraft.spruce_wall_hanging_sign": "壁中樅懸牌",
  "block.minecraft.spruce_wall_sign": "壁中樅牌",
  "block.minecraft.spruce_wood": "樅木",
  "block.minecraft.sticky_piston": "黏膠鞲鞴",
  "block.minecraft.stone": "石",
  "block.minecraft.stone_brick_slab": "石磚版",
  "block.minecraft.stone_brick_stairs": "石磚階",
  "block.minecraft.stone_brick_wall": "石磚垣",
  "block.minecraft.stone_bricks": "石磚",
  "block.minecraft.stone_button": "石鈕",
  "block.minecraft.stone_pressure_plate": "石踏板",
  "block.minecraft.stone_slab": "石版",
  "block.minecraft.stone_stairs": "石階",
  "block.minecraft.stonecutter": "鑿石器",
  "block.minecraft.stripped_acacia_log": "既扡㭜樁",
  "block.minecraft.stripped_acacia_wood": "既扡㭜木",
  "block.minecraft.stripped_bamboo_block": "既扡竹塊",
  "block.minecraft.stripped_birch_log": "既扡樺樁",
  "block.minecraft.stripped_birch_wood": "既扡樺木",
  "block.minecraft.stripped_cherry_log": "既扡櫻樁",
  "block.minecraft.stripped_cherry_wood": "既扡櫻木",
  "block.minecraft.stripped_crimson_hyphae": "既扡緋蕈體",
  "block.minecraft.stripped_crimson_stem": "既扡緋蕈柄",
  "block.minecraft.stripped_dark_oak_log": "既扡黯柞樁",
  "block.minecraft.stripped_dark_oak_wood": "既扡黯柞木",
  "block.minecraft.stripped_jungle_log": "既扡叢莽樁",
  "block.minecraft.stripped_jungle_wood": "既扡叢莽木",
  "block.minecraft.stripped_mangrove_log": "既扡沒潮木樁",
  "block.minecraft.stripped_mangrove_wood": "既扡沒潮木",
  "block.minecraft.stripped_oak_log": "既扡柞樁",
  "block.minecraft.stripped_oak_wood": "既扡柞木",
  "block.minecraft.stripped_pale_oak_log": "既扡縞柞樁",
  "block.minecraft.stripped_pale_oak_wood": "既扡縞柞木",
  "block.minecraft.stripped_spruce_log": "既扡樅樁",
  "block.minecraft.stripped_spruce_wood": "既扡樅木",
  "block.minecraft.stripped_warped_hyphae": "既扡譎蕈體",
  "block.minecraft.stripped_warped_stem": "既扡譎蕈柄",
  "block.minecraft.structure_block": "築塊",
  "block.minecraft.structure_void": "築闕",
  "block.minecraft.sugar_cane": "蔗",
  "block.minecraft.sunflower": "葵藿",
  "block.minecraft.suspicious_gravel": "謎礫",
  "block.minecraft.suspicious_sand": "謎沙",
  "block.minecraft.sweet_berry_bush": "甜莓叢",
  "block.minecraft.tall_dry_grass": "高枯艸",
  "block.minecraft.tall_grass": "高艸",
  "block.minecraft.tall_seagrass": "高海艸",
  "block.minecraft.target": "靶",
  "block.minecraft.terracotta": "陶",
  "block.minecraft.test_block": "測塊",
  "block.minecraft.test_instance_block": "測例塊",
  "block.minecraft.tinted_glass": "蔽明琉璃",
  "block.minecraft.tnt": "灹藥",
  "block.minecraft.tnt.disabled": "灹藥既禁爆",
  "block.minecraft.torch": "炬",
  "block.minecraft.torchflower": "炬蓮",
  "block.minecraft.torchflower_crop": "炬蓮株",
  "block.minecraft.trapped_chest": "機關箱",
  "block.minecraft.trial_spawner": "煉孳衍籠",
  "block.minecraft.tripwire": "絆綫",
  "block.minecraft.tripwire_hook": "絆綫鉤",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.tube_coral_block": "管珊瑚塊",
  "block.minecraft.tube_coral_fan": "扇狀管珊瑚",
  "block.minecraft.tube_coral_wall_fan": "壁中扇狀管珊瑚",
  "block.minecraft.tuff": "積塊石",
  "block.minecraft.tuff_brick_slab": "積塊石磚版",
  "block.minecraft.tuff_brick_stairs": "積塊石磚階",
  "block.minecraft.tuff_brick_wall": "積塊石磚垣",
  "block.minecraft.tuff_bricks": "積塊石磚",
  "block.minecraft.tuff_slab": "積塊石版",
  "block.minecraft.tuff_stairs": "積塊石階",
  "block.minecraft.tuff_wall": "積塊石垣",
  "block.minecraft.turtle_egg": "海龜卵",
  "block.minecraft.twisting_vines": "輪囷藤",
  "block.minecraft.twisting_vines_plant": "輪囷藤株",
  "block.minecraft.vault": "寶篋",
  "block.minecraft.verdant_froglight": "翠鼃光",
  "block.minecraft.vine": "藤",
  "block.minecraft.void_air": "虛氣",
  "block.minecraft.wall_torch": "壁中炬",
  "block.minecraft.warped_button": "譎蕈木鈕",
  "block.minecraft.warped_door": "譎蕈木門",
  "block.minecraft.warped_fence": "譎蕈木檻",
  "block.minecraft.warped_fence_gate": "譎蕈木扉",
  "block.minecraft.warped_fungus": "譎蕈",
  "block.minecraft.warped_hanging_sign": "譎蕈木懸牌",
  "block.minecraft.warped_hyphae": "譎蕈體",
  "block.minecraft.warped_nylium": "譎蕈石",
  "block.minecraft.warped_planks": "譎蕈木材",
  "block.minecraft.warped_pressure_plate": "譎蕈木踏板",
  "block.minecraft.warped_roots": "譎蕈索",
  "block.minecraft.warped_shelf": "譎蕈櫥",
  "block.minecraft.warped_sign": "譎蕈木牌",
  "block.minecraft.warped_slab": "譎蕈木版",
  "block.minecraft.warped_stairs": "譎蕈木階",
  "block.minecraft.warped_stem": "譎蕈柄",
  "block.minecraft.warped_trapdoor": "譎蕈木窖門",
  "block.minecraft.warped_wall_hanging_sign": "壁中譎蕈木懸牌",
  "block.minecraft.warped_wall_sign": "壁中譎蕈木牌",
  "block.minecraft.warped_wart_block": "譎疣塊",
  "block.minecraft.water": "水",
  "block.minecraft.water_cauldron": "瀦水之釜",
  "block.minecraft.waxed_chiseled_copper": "蠟引雕銅塊",
  "block.minecraft.waxed_copper_bars": "蠟引銅檻",
  "block.minecraft.waxed_copper_block": "蠟引銅塊",
  "block.minecraft.waxed_copper_bulb": "蠟引銅燈",
  "block.minecraft.waxed_copper_chain": "蠟引銅鏈",
  "block.minecraft.waxed_copper_chest": "蠟引銅箱",
  "block.minecraft.waxed_copper_door": "蠟引銅門",
  "block.minecraft.waxed_copper_golem_statue": "蠟引銅傀儡俑",
  "block.minecraft.waxed_copper_grate": "蠟引銅柵網",
  "block.minecraft.waxed_copper_lantern": "蠟引銅燈籠",
  "block.minecraft.waxed_copper_trapdoor": "蠟引銅窖門",
  "block.minecraft.waxed_cut_copper": "蠟引割銅塊",
  "block.minecraft.waxed_cut_copper_slab": "蠟引割銅版",
  "block.minecraft.waxed_cut_copper_stairs": "蠟引割銅階",
  "block.minecraft.waxed_exposed_chiseled_copper": "蠟引渡濕雕銅塊",
  "block.minecraft.waxed_exposed_copper": "蠟引渡濕銅塊",
  "block.minecraft.waxed_exposed_copper_bars": "蠟引渡濕銅檻",
  "block.minecraft.waxed_exposed_copper_bulb": "蠟引渡濕銅燈",
  "block.minecraft.waxed_exposed_copper_chain": "蠟引渡濕銅鏈",
  "block.minecraft.waxed_exposed_copper_chest": "蠟引渡濕銅箱",
  "block.minecraft.waxed_exposed_copper_door": "蠟引渡濕銅門",
  "block.minecraft.waxed_exposed_copper_golem_statue": "蠟引渡濕銅傀儡俑",
  "block.minecraft.waxed_exposed_copper_grate": "蠟引渡濕銅柵網",
  "block.minecraft.waxed_exposed_copper_lantern": "蠟引渡濕銅燈籠",
  "block.minecraft.waxed_exposed_copper_trapdoor": "蠟引渡濕銅窖門",
  "block.minecraft.waxed_exposed_cut_copper": "蠟引渡濕割銅塊",
  "block.minecraft.waxed_exposed_cut_copper_slab": "蠟引渡濕割銅版",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "蠟引渡濕割銅階",
  "block.minecraft.waxed_exposed_lightning_rod": "蠟引渡濕引雷桿",
  "block.minecraft.waxed_lightning_rod": "蠟引引雷桿",
  "block.minecraft.waxed_oxidized_chiseled_copper": "蠟引風蝕雕銅塊",
  "block.minecraft.waxed_oxidized_copper": "蠟引風蝕銅塊",
  "block.minecraft.waxed_oxidized_copper_bars": "蠟引風蝕銅檻",
  "block.minecraft.waxed_oxidized_copper_bulb": "蠟引風蝕銅燈",
  "block.minecraft.waxed_oxidized_copper_chain": "蠟引風蝕銅鏈",
  "block.minecraft.waxed_oxidized_copper_chest": "蠟引風蝕銅箱",
  "block.minecraft.waxed_oxidized_copper_door": "蠟引風蝕銅門",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "蠟引風蝕銅傀儡俑",
  "block.minecraft.waxed_oxidized_copper_grate": "蠟引風蝕銅柵網",
  "block.minecraft.waxed_oxidized_copper_lantern": "蠟引風蝕銅燈籠",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "蠟引風蝕銅窖門",
  "block.minecraft.waxed_oxidized_cut_copper": "蠟引風蝕割銅塊",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "蠟引風蝕割銅版",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "蠟引風蝕割銅階",
  "block.minecraft.waxed_oxidized_lightning_rod": "蠟引風蝕引雷桿",
  "block.minecraft.waxed_weathered_chiseled_copper": "蠟引鏽刻雕銅塊",
  "block.minecraft.waxed_weathered_copper": "蠟引鏽刻銅塊",
  "block.minecraft.waxed_weathered_copper_bars": "蠟引鏽刻銅檻",
  "block.minecraft.waxed_weathered_copper_bulb": "蠟引鏽刻銅燈",
  "block.minecraft.waxed_weathered_copper_chain": "蠟引鏽刻銅鏈",
  "block.minecraft.waxed_weathered_copper_chest": "蠟引鏽刻銅箱",
  "block.minecraft.waxed_weathered_copper_door": "蠟引鏽刻銅門",
  "block.minecraft.waxed_weathered_copper_golem_statue": "蠟引鏽刻銅傀儡俑",
  "block.minecraft.waxed_weathered_copper_grate": "蠟引鏽刻銅柵網",
  "block.minecraft.waxed_weathered_copper_lantern": "蠟引鏽刻銅燈籠",
  "block.minecraft.waxed_weathered_copper_trapdoor": "蠟引鏽刻銅窖門",
  "block.minecraft.waxed_weathered_cut_copper": "蠟引鏽刻割銅塊",
  "block.minecraft.waxed_weathered_cut_copper_slab": "蠟引鏽刻割銅版",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "蠟引鏽刻割銅階",
  "block.minecraft.waxed_weathered_lightning_rod": "蠟引鏽刻引雷桿",
  "block.minecraft.weathered_chiseled_copper": "鏽刻雕銅塊",
  "block.minecraft.weathered_copper": "鏽刻銅塊",
  "block.minecraft.weathered_copper_bars": "鏽刻銅檻",
  "block.minecraft.weathered_copper_bulb": "鏽刻銅燈",
  "block.minecraft.weathered_copper_chain": "鏽刻銅鏈",
  "block.minecraft.weathered_copper_chest": "鏽刻銅箱",
  "block.minecraft.weathered_copper_door": "鏽刻銅門",
  "block.minecraft.weathered_copper_golem_statue": "鏽刻銅傀儡俑",
  "block.minecraft.weathered_copper_grate": "鏽刻銅柵網",
  "block.minecraft.weathered_copper_lantern": "鏽刻銅燈籠",
  "block.minecraft.weathered_copper_trapdoor": "鏽刻銅窖門",
  "block.minecraft.weathered_cut_copper": "鏽刻割銅塊",
  "block.minecraft.weathered_cut_copper_slab": "鏽刻割銅版",
  "block.minecraft.weathered_cut_copper_stairs": "鏽刻割銅階",
  "block.minecraft.weathered_lightning_rod": "鏽刻引雷桿",
  "block.minecraft.weeping_vines": "垂泣藤",
  "block.minecraft.weeping_vines_plant": "垂泣藤株",
  "block.minecraft.wet_sponge": "㵖海綿",
  "block.minecraft.wheat": "麥禾",
  "block.minecraft.white_banner": "素旗",
  "block.minecraft.white_bed": "白床",
  "block.minecraft.white_candle": "白燭",
  "block.minecraft.white_candle_cake": "白燭之洋糕",
  "block.minecraft.white_carpet": "白氍毹",
  "block.minecraft.white_concrete": "白砼",
  "block.minecraft.white_concrete_powder": "白砼粉",
  "block.minecraft.white_glazed_terracotta": "白釉陶",
  "block.minecraft.white_shulker_box": "白贆櫝",
  "block.minecraft.white_stained_glass": "白琉璃",
  "block.minecraft.white_stained_glass_pane": "白琉璃嵌板",
  "block.minecraft.white_terracotta": "白陶",
  "block.minecraft.white_tulip": "白鬱金香",
  "block.minecraft.white_wool": "白羊毛",
  "block.minecraft.wildflowers": "野芳叢",
  "block.minecraft.wither_rose": "凋靈玫瑰",
  "block.minecraft.wither_skeleton_skull": "凋靈髑首",
  "block.minecraft.wither_skeleton_wall_skull": "壁中凋靈髑首",
  "block.minecraft.yellow_banner": "黃旗",
  "block.minecraft.yellow_bed": "黃床",
  "block.minecraft.yellow_candle": "黃燭",
  "block.minecraft.yellow_candle_cake": "黃燭之洋糕",
  "block.minecraft.yellow_carpet": "黃氍毹",
  "block.minecraft.yellow_concrete": "黃砼",
  "block.minecraft.yellow_concrete_powder": "黃砼粉",
  "block.minecraft.yellow_glazed_terracotta": "黃釉陶",
  "block.minecraft.yellow_shulker_box": "黃贆櫝",
  "block.minecraft.yellow_stained_glass": "黃琉璃",
  "block.minecraft.yellow_stained_glass_pane": "黃琉璃嵌板",
  "block.minecraft.yellow_terracotta": "黃陶",
  "block.minecraft.yellow_wool": "黃羊毛",
  "block.minecraft.zombie_head": "殭屍首",
  "block.minecraft.zombie_wall_head": "壁中殭屍首",
  "item.minecraft.acacia_boat": "㭜舟",
  "item.minecraft.acacia_chest_boat": "㭜艚",
  "item.minecraft.allay_spawn_egg": "孳悅靈之卵",
  "item.minecraft.amethyst_shard": "紫水玉片",
  "item.minecraft.angler_pottery_shard": "釣陶片",
  "item.minecraft.angler_pottery_sherd": "釣陶片",
  "item.minecraft.apple": "林檎",
  "item.minecraft.archer_pottery_shard": "射陶片",
  "item.minecraft.archer_pottery_sherd": "射陶片",
  "item.minecraft.armadillo_scute": "犰狳鱗",
  "item.minecraft.armadillo_spawn_egg": "孳犰狳之卵",
  "item.minecraft.armor_stand": "甲桁",
  "item.minecraft.arms_up_pottery_shard": "肱陶片",
  "item.minecraft.arms_up_pottery_sherd": "肱陶片",
  "item.minecraft.arrow": "矢",
  "item.minecraft.axolotl_bucket": "螈桶",
  "item.minecraft.axolotl_spawn_egg": "孳螈之卵",
  "item.minecraft.baked_potato": "洋芋炙",
  "item.minecraft.bamboo_chest_raft": "竹艚",
  "item.minecraft.bamboo_raft": "竹筏",
  "item.minecraft.bat_spawn_egg": "孳蟙䘃之卵",
  "item.minecraft.bee_spawn_egg": "孳蜂之卵",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.beetroot": "甘藜根",
  "item.minecraft.beetroot_seeds": "甘藜種",
  "item.minecraft.beetroot_soup": "甘藜羹",
  "item.minecraft.birch_boat": "樺舟",
  "item.minecraft.birch_chest_boat": "樺艚",
  "item.minecraft.black_bundle": "玄皮囊",
  "item.minecraft.black_dye": "黑染",
  "item.minecraft.black_harness": "黑轡",
  "item.minecraft.blade_pottery_shard": "刃陶片",
  "item.minecraft.blade_pottery_sherd": "刃陶片",
  "item.minecraft.blaze_powder": "炎靈粉",
  "item.minecraft.blaze_rod": "炎靈桿",
  "item.minecraft.blaze_spawn_egg": "孳炎靈之卵",
  "item.minecraft.blue_bundle": "靛皮囊",
  "item.minecraft.blue_dye": "靛染",
  "item.minecraft.blue_egg": "靛雞卵",
  "item.minecraft.blue_harness": "靛轡",
  "item.minecraft.bogged_spawn_egg": "孳濘髑之卵",
  "item.minecraft.bolt_armor_trim_smithing_template": "鍛模",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "榫卯甲紋",
  "item.minecraft.bone": "骨",
  "item.minecraft.bone_meal": "骨塵",
  "item.minecraft.book": "書",
  "item.minecraft.bordure_indented_banner_pattern": "齒匡旗楷",
  "item.minecraft.bow": "弓",
  "item.minecraft.bowl": "椀",
  "item.minecraft.bread": "饢",
  "item.minecraft.breeze_rod": "風靈桿",
  "item.minecraft.breeze_spawn_egg": "孳風靈之卵",
  "item.minecraft.brewer_pottery_shard": "釀陶片",
  "item.minecraft.brewer_pottery_sherd": "釀陶片",
  "item.minecraft.brewing_stand": "煉藥臺",
  "item.minecraft.brick": "磚",
  "item.minecraft.brown_bundle": "褐皮囊",
  "item.minecraft.brown_dye": "褐染",
  "item.minecraft.brown_egg": "褐雞卵",
  "item.minecraft.brown_harness": "褐轡",
  "item.minecraft.brush": "刷",
  "item.minecraft.bucket": "桶",
  "item.minecraft.bundle": "皮囊",
  "item.minecraft.bundle.empty": "空",
  "item.minecraft.bundle.empty.description": "可納雜物一組",
  "item.minecraft.bundle.full": "盈",
  "item.minecraft.bundle.fullness": "%2$s之%1$s",
  "item.minecraft.burn_pottery_shard": "燊陶片",
  "item.minecraft.burn_pottery_sherd": "燊陶片",
  "item.minecraft.camel_husk_spawn_egg": "孳枯橐駝之卵",
  "item.minecraft.camel_spawn_egg": "孳橐駝之卵",
  "item.minecraft.carrot": "胡蘆菔",
  "item.minecraft.carrot_on_a_stick": "胡蘆菔釣竿",
  "item.minecraft.cat_spawn_egg": "孳貓之卵",
  "item.minecraft.cauldron": "釜",
  "item.minecraft.cave_spider_spawn_egg": "孳穴蛛之卵",
  "item.minecraft.chainmail_boots": "環鎖鞾",
  "item.minecraft.chainmail_chestplate": "環鎖鎧",
  "item.minecraft.chainmail_helmet": "環鎖胄",
  "item.minecraft.chainmail_leggings": "環鎖護腿",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.cherry_boat": "櫻舟",
  "item.minecraft.cherry_chest_boat": "櫻艚",
  "item.minecraft.chest_minecart": "箱礦車",
  "item.minecraft.chicken": "生雞肉",
  "item.minecraft.chicken_spawn_egg": "孳雞之卵",
  "item.minecraft.chorus_fruit": "頌緲果",
  "item.minecraft.clay_ball": "埴團",
  "item.minecraft.clock": "晷漏",
  "item.minecraft.coal": "石炭",
  "item.minecraft.coast_armor_trim_smithing_template": "鍛模",
  "item.minecraft.coast_armor_trim_smithing_template.new": "邊海甲紋",
  "item.minecraft.cocoa_beans": "可可荳",
  "item.minecraft.cod": "生鱈",
  "item.minecraft.cod_bucket": "鱈桶",
  "item.minecraft.cod_spawn_egg": "孳鱈之卵",
  "item.minecraft.command_block_minecart": "命令塊礦車",
  "item.minecraft.compass": "司南",
  "item.minecraft.cooked_beef": "牛炙",
  "item.minecraft.cooked_chicken": "雞炙",
  "item.minecraft.cooked_cod": "鱈炙",
  "item.minecraft.cooked_mutton": "羊炙",
  "item.minecraft.cooked_porkchop": "豕炙",
  "item.minecraft.cooked_rabbit": "兔炙",
  "item.minecraft.cooked_salmon": "鮭炙",
  "item.minecraft.cookie": "餠",
  "item.minecraft.copper_axe": "銅斧",
  "item.minecraft.copper_boots": "銅鞾",
  "item.minecraft.copper_chestplate": "銅鎧",
  "item.minecraft.copper_golem_spawn_egg": "孳銅傀儡之卵",
  "item.minecraft.copper_helmet": "銅胄",
  "item.minecraft.copper_hoe": "銅鋤",
  "item.minecraft.copper_horse_armor": "銅馬甲",
  "item.minecraft.copper_ingot": "銅錠",
  "item.minecraft.copper_leggings": "銅護腿",
  "item.minecraft.copper_nautilus_armor": "銅鸚鵡螺甲",
  "item.minecraft.copper_nugget": "銅粒",
  "item.minecraft.copper_pickaxe": "銅鎬",
  "item.minecraft.copper_shovel": "銅鍁",
  "item.minecraft.copper_spear": "銅槊",
  "item.minecraft.copper_sword": "銅劍",
  "item.minecraft.cow_spawn_egg": "孳牛之卵",
  "item.minecraft.creaking_spawn_egg": "孳䦪鬼之卵",
  "item.minecraft.creeper_banner_pattern": "旗楷",
  "item.minecraft.creeper_banner_pattern.desc": "伏臨紋",
  "item.minecraft.creeper_banner_pattern.new": "伏臨紋旗楷",
  "item.minecraft.creeper_spawn_egg": "孳伏臨之卵",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.crossbow.projectile": "彈：",
  "item.minecraft.crossbow.projectile.multiple": "彈：%s者%s",
  "item.minecraft.crossbow.projectile.single": "彈：%s",
  "item.minecraft.cyan_bundle": "黛皮囊",
  "item.minecraft.cyan_dye": "黛染",
  "item.minecraft.cyan_harness": "黛轡",
  "item.minecraft.danger_pottery_shard": "殆陶片",
  "item.minecraft.danger_pottery_sherd": "殆陶片",
  "item.minecraft.dark_oak_boat": "黯柞舟",
  "item.minecraft.dark_oak_chest_boat": "黯柞艚",
  "item.minecraft.debug_stick": "勘誤棍",
  "item.minecraft.debug_stick.empty": "%s無品",
  "item.minecraft.debug_stick.select": "擇「%s」（%s）",
  "item.minecraft.debug_stick.update": "設「%s」爲%s",
  "item.minecraft.diamond": "金剛石",
  "item.minecraft.diamond_axe": "金剛斧",
  "item.minecraft.diamond_boots": "金剛鞾",
  "item.minecraft.diamond_chestplate": "金剛鎧",
  "item.minecraft.diamond_helmet": "金剛胄",
  "item.minecraft.diamond_hoe": "金剛鋤",
  "item.minecraft.diamond_horse_armor": "金剛馬甲",
  "item.minecraft.diamond_leggings": "金剛護腿",
  "item.minecraft.diamond_nautilus_armor": "金剛鸚鵡螺甲",
  "item.minecraft.diamond_pickaxe": "金剛鎬",
  "item.minecraft.diamond_shovel": "金剛鍁",
  "item.minecraft.diamond_spear": "金剛槊",
  "item.minecraft.diamond_sword": "金剛劍",
  "item.minecraft.disc_fragment_5": "留聲盤殘片",
  "item.minecraft.disc_fragment_5.desc": "留聲盤 - 5",
  "item.minecraft.dolphin_spawn_egg": "孳海豚之卵",
  "item.minecraft.donkey_spawn_egg": "孳驢之卵",
  "item.minecraft.dragon_breath": "龍涎",
  "item.minecraft.dried_kelp": "乾海帶",
  "item.minecraft.drowned_spawn_egg": "孳溺屍之卵",
  "item.minecraft.dune_armor_trim_smithing_template": "鍛模",
  "item.minecraft.dune_armor_trim_smithing_template.new": "沙墩甲紋",
  "item.minecraft.echo_shard": "回音殘片",
  "item.minecraft.egg": "雞卵",
  "item.minecraft.elder_guardian_spawn_egg": "孳古海衛之卵",
  "item.minecraft.elytra": "翼",
  "item.minecraft.emerald": "祖母綠",
  "item.minecraft.enchanted_book": "淬靈書",
  "item.minecraft.enchanted_golden_apple": "淬靈金林檎",
  "item.minecraft.end_crystal": "終界水玉",
  "item.minecraft.ender_dragon_spawn_egg": "孳終眇龍之卵",
  "item.minecraft.ender_eye": "終眇眼",
  "item.minecraft.ender_pearl": "終眇玥",
  "item.minecraft.enderman_spawn_egg": "孳終眇使之卵",
  "item.minecraft.endermite_spawn_egg": "孳終眇蟎之卵",
  "item.minecraft.evoker_spawn_egg": "孳御魔使之卵",
  "item.minecraft.experience_bottle": "淬靈甁",
  "item.minecraft.explorer_pottery_shard": "探陶片",
  "item.minecraft.explorer_pottery_sherd": "探陶片",
  "item.minecraft.eye_armor_trim_smithing_template": "鍛模",
  "item.minecraft.eye_armor_trim_smithing_template.new": "瞳眸甲紋",
  "item.minecraft.feather": "羽",
  "item.minecraft.fermented_spider_eye": "酵化蛛目",
  "item.minecraft.field_masoned_banner_pattern": "磚紋旗楷",
  "item.minecraft.filled_map": "輿圖",
  "item.minecraft.fire_charge": "焰彈",
  "item.minecraft.firework_rocket": "焰火",
  "item.minecraft.firework_rocket.flight": "昇之時：",
  "item.minecraft.firework_rocket.multiple_stars": "%s乘%s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "焰火之星",
  "item.minecraft.firework_star.black": "黑",
  "item.minecraft.firework_star.blue": "靛",
  "item.minecraft.firework_star.brown": "褐",
  "item.minecraft.firework_star.custom_color": "自定",
  "item.minecraft.firework_star.cyan": "黛",
  "item.minecraft.firework_star.fade_to": "漸隱",
  "item.minecraft.firework_star.flicker": "爍",
  "item.minecraft.firework_star.gray": "灰",
  "item.minecraft.firework_star.green": "綠",
  "item.minecraft.firework_star.light_blue": "縹",
  "item.minecraft.firework_star.light_gray": "蒼",
  "item.minecraft.firework_star.lime": "翠",
  "item.minecraft.firework_star.magenta": "赬",
  "item.minecraft.firework_star.orange": "橙",
  "item.minecraft.firework_star.pink": "紅",
  "item.minecraft.firework_star.purple": "紫",
  "item.minecraft.firework_star.red": "赤",
  "item.minecraft.firework_star.shape": "未明之狀",
  "item.minecraft.firework_star.shape.burst": "爆裂",
  "item.minecraft.firework_star.shape.creeper": "伏臨狀",
  "item.minecraft.firework_star.shape.large_ball": "大圓狀",
  "item.minecraft.firework_star.shape.small_ball": "小圓狀",
  "item.minecraft.firework_star.shape.star": "星狀",
  "item.minecraft.firework_star.trail": "跡",
  "item.minecraft.firework_star.white": "白",
  "item.minecraft.firework_star.yellow": "黃",
  "item.minecraft.fishing_rod": "漁竿",
  "item.minecraft.flint": "燧石",
  "item.minecraft.flint_and_steel": "燧鐮",
  "item.minecraft.flow_armor_trim_smithing_template": "鍛模",
  "item.minecraft.flow_armor_trim_smithing_template.new": "氣洄甲紋",
  "item.minecraft.flow_banner_pattern": "旗楷",
  "item.minecraft.flow_banner_pattern.desc": "氣洄紋",
  "item.minecraft.flow_banner_pattern.new": "氣洄紋旗楷",
  "item.minecraft.flow_pottery_sherd": "湍陶片",
  "item.minecraft.flower_banner_pattern": "旗楷",
  "item.minecraft.flower_banner_pattern.desc": "菊紋",
  "item.minecraft.flower_banner_pattern.new": "花紋旗楷",
  "item.minecraft.flower_pot": "盆",
  "item.minecraft.fox_spawn_egg": "孳狐之卵",
  "item.minecraft.friend_pottery_shard": "友陶片",
  "item.minecraft.friend_pottery_sherd": "友陶片",
  "item.minecraft.frog_spawn_egg": "孳鼃之卵",
  "item.minecraft.furnace_minecart": "爐礦車",
  "item.minecraft.ghast_spawn_egg": "孳魄之卵",
  "item.minecraft.ghast_tear": "魄淚",
  "item.minecraft.glass_bottle": "琉璃甁",
  "item.minecraft.glistering_melon_slice": "爍寒瓜片",
  "item.minecraft.globe_banner_pattern": "旗楷",
  "item.minecraft.globe_banner_pattern.desc": "坤輿紋",
  "item.minecraft.globe_banner_pattern.new": "坤輿紋旗楷",
  "item.minecraft.glow_berries": "爍莓",
  "item.minecraft.glow_ink_sac": "爍墨",
  "item.minecraft.glow_item_frame": "爍置具匡",
  "item.minecraft.glow_squid_spawn_egg": "孳爍鰂之卵",
  "item.minecraft.glowstone_dust": "硄砂",
  "item.minecraft.goat_horn": "山羊角",
  "item.minecraft.goat_spawn_egg": "孳山羊之卵",
  "item.minecraft.gold_ingot": "金錠",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.golden_apple": "金林檎",
  "item.minecraft.golden_axe": "金斧",
  "item.minecraft.golden_boots": "金鞾",
  "item.minecraft.golden_carrot": "金胡蘆菔",
  "item.minecraft.golden_chestplate": "金鎧",
  "item.minecraft.golden_helmet": "金胄",
  "item.minecraft.golden_hoe": "金鋤",
  "item.minecraft.golden_horse_armor": "金馬甲",
  "item.minecraft.golden_leggings": "金護腿",
  "item.minecraft.golden_nautilus_armor": "金鸚鵡螺甲",
  "item.minecraft.golden_pickaxe": "金鎬",
  "item.minecraft.golden_shovel": "金鍁",
  "item.minecraft.golden_spear": "金槊",
  "item.minecraft.golden_sword": "金劍",
  "item.minecraft.gray_bundle": "灰皮囊",
  "item.minecraft.gray_dye": "灰染",
  "item.minecraft.gray_harness": "灰轡",
  "item.minecraft.green_bundle": "綠皮囊",
  "item.minecraft.green_dye": "綠染",
  "item.minecraft.green_harness": "綠轡",
  "item.minecraft.guardian_spawn_egg": "孳海衛之卵",
  "item.minecraft.gunpowder": "火藥",
  "item.minecraft.guster_banner_pattern": "旗楷",
  "item.minecraft.guster_banner_pattern.desc": "飆紋",
  "item.minecraft.guster_banner_pattern.new": "飆紋旗楷",
  "item.minecraft.guster_pottery_sherd": "飆陶片",
  "item.minecraft.happy_ghast_spawn_egg": "孳悅魄之卵",
  "item.minecraft.harness": "轡",
  "item.minecraft.heart_of_the_sea": "海之心",
  "item.minecraft.heart_pottery_shard": "心陶片",
  "item.minecraft.heart_pottery_sherd": "心陶片",
  "item.minecraft.heartbreak_pottery_shard": "慟陶片",
  "item.minecraft.heartbreak_pottery_sherd": "慟陶片",
  "item.minecraft.hoglin_spawn_egg": "孳獷豕之卵",
  "item.minecraft.honey_bottle": "蜜甁",
  "item.minecraft.honeycomb": "蜜脾",
  "item.minecraft.hopper_minecart": "漏斗礦車",
  "item.minecraft.horse_spawn_egg": "孳馬之卵",
  "item.minecraft.host_armor_trim_smithing_template": "鍛模",
  "item.minecraft.host_armor_trim_smithing_template.new": "佃東甲紋",
  "item.minecraft.howl_pottery_shard": "嚎陶片",
  "item.minecraft.howl_pottery_sherd": "嚎陶片",
  "item.minecraft.husk_spawn_egg": "孳枯屍之卵",
  "item.minecraft.ink_sac": "墨",
  "item.minecraft.iron_axe": "鐵斧",
  "item.minecraft.iron_boots": "鐵鞾",
  "item.minecraft.iron_chestplate": "鐵鎧",
  "item.minecraft.iron_golem_spawn_egg": "孳鐵傀儡之卵",
  "item.minecraft.iron_helmet": "鐵胄",
  "item.minecraft.iron_hoe": "鐵鋤",
  "item.minecraft.iron_horse_armor": "鐵馬甲",
  "item.minecraft.iron_ingot": "鐵錠",
  "item.minecraft.iron_leggings": "鐵護腿",
  "item.minecraft.iron_nautilus_armor": "鐵鸚鵡螺甲",
  "item.minecraft.iron_nugget": "鐵粒",
  "item.minecraft.iron_pickaxe": "鐵鎬",
  "item.minecraft.iron_shovel": "鐵鍁",
  "item.minecraft.iron_spear": "鐵槊",
  "item.minecraft.iron_sword": "鐵劍",
  "item.minecraft.item_frame": "置具匡",
  "item.minecraft.jungle_boat": "叢莽舟",
  "item.minecraft.jungle_chest_boat": "叢莽艚",
  "item.minecraft.knowledge_book": "天工開物",
  "item.minecraft.lapis_lazuli": "群青",
  "item.minecraft.lava_bucket": "熔石桶",
  "item.minecraft.lead": "韁",
  "item.minecraft.leather": "革",
  "item.minecraft.leather_boots": "革鞾",
  "item.minecraft.leather_chestplate": "革衣",
  "item.minecraft.leather_helmet": "革帽",
  "item.minecraft.leather_horse_armor": "革馬甲",
  "item.minecraft.leather_leggings": "革褲",
  "item.minecraft.light_blue_bundle": "縹皮囊",
  "item.minecraft.light_blue_dye": "縹染",
  "item.minecraft.light_blue_harness": "縹轡",
  "item.minecraft.light_gray_bundle": "蒼皮囊",
  "item.minecraft.light_gray_dye": "蒼染",
  "item.minecraft.light_gray_harness": "蒼轡",
  "item.minecraft.lime_bundle": "翠皮囊",
  "item.minecraft.lime_dye": "翠染",
  "item.minecraft.lime_harness": "翠轡",
  "item.minecraft.lingering_potion": "滯劑",
  "item.minecraft.lingering_potion.effect.awkward": "粗滯劑",
  "item.minecraft.lingering_potion.effect.empty": "空滯劑",
  "item.minecraft.lingering_potion.effect.fire_resistance": "抗火滯劑",
  "item.minecraft.lingering_potion.effect.harming": "瞬傷滯劑",
  "item.minecraft.lingering_potion.effect.healing": "瞬療滯劑",
  "item.minecraft.lingering_potion.effect.infested": "蟫蝕滯劑",
  "item.minecraft.lingering_potion.effect.invisibility": "隱滯劑",
  "item.minecraft.lingering_potion.effect.leaping": "捷滯劑",
  "item.minecraft.lingering_potion.effect.levitation": "浮滯劑",
  "item.minecraft.lingering_potion.effect.luck": "幸滯劑",
  "item.minecraft.lingering_potion.effect.mundane": "凡滯劑",
  "item.minecraft.lingering_potion.effect.night_vision": "夜視滯劑",
  "item.minecraft.lingering_potion.effect.oozing": "滲膠滯劑",
  "item.minecraft.lingering_potion.effect.poison": "毒滯劑",
  "item.minecraft.lingering_potion.effect.regeneration": "甦滯劑",
  "item.minecraft.lingering_potion.effect.slow_falling": "輕滯劑",
  "item.minecraft.lingering_potion.effect.slowness": "緩滯劑",
  "item.minecraft.lingering_potion.effect.strength": "力滯劑",
  "item.minecraft.lingering_potion.effect.swiftness": "速滯劑",
  "item.minecraft.lingering_potion.effect.thick": "濁滯劑",
  "item.minecraft.lingering_potion.effect.turtle_master": "龜仙滯劑",
  "item.minecraft.lingering_potion.effect.water": "水滯劑",
  "item.minecraft.lingering_potion.effect.water_breathing": "水肺滯劑",
  "item.minecraft.lingering_potion.effect.weakness": "虛滯劑",
  "item.minecraft.lingering_potion.effect.weaving": "綴絲滯劑",
  "item.minecraft.lingering_potion.effect.wind_charged": "厲風滯劑",
  "item.minecraft.llama_spawn_egg": "孳美洲駝之卵",
  "item.minecraft.lodestone_compass": "礠石司南",
  "item.minecraft.mace": "椎",
  "item.minecraft.magenta_bundle": "赬皮囊",
  "item.minecraft.magenta_dye": "赬染",
  "item.minecraft.magenta_harness": "赬轡",
  "item.minecraft.magma_cream": "火漿膏",
  "item.minecraft.magma_cube_spawn_egg": "孳火漿魔之卵",
  "item.minecraft.mangrove_boat": "沒潮木舟",
  "item.minecraft.mangrove_chest_boat": "沒潮木艚",
  "item.minecraft.map": "空圖",
  "item.minecraft.melon_seeds": "寒瓜種",
  "item.minecraft.melon_slice": "寒瓜片",
  "item.minecraft.milk_bucket": "乳桶",
  "item.minecraft.minecart": "礦車",
  "item.minecraft.miner_pottery_shard": "礦陶片",
  "item.minecraft.miner_pottery_sherd": "礦陶片",
  "item.minecraft.mojang_banner_pattern": "旗楷",
  "item.minecraft.mojang_banner_pattern.desc": "魔贊紋",
  "item.minecraft.mojang_banner_pattern.new": "魔贊紋旗楷",
  "item.minecraft.mooshroom_spawn_egg": "孳牟蕈之卵",
  "item.minecraft.mourner_pottery_shard": "悲陶片",
  "item.minecraft.mourner_pottery_sherd": "悲陶片",
  "item.minecraft.mule_spawn_egg": "孳騾之卵",
  "item.minecraft.mushroom_stew": "蕈羹",
  "item.minecraft.music_disc_11": "留聲盤",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "留聲盤",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "留聲盤",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "留聲盤",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "留聲盤",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "留聲盤",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "留聲盤",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "留聲盤",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator（五音匣）",
  "item.minecraft.music_disc_far": "留聲盤",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "留聲盤",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "留聲盤",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "留聲盤",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "留聲盤",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "留聲盤",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "留聲盤",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "留聲盤",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "留聲盤",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "留聲盤",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "留聲盤",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "留聲盤",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "留聲盤",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.name_tag": "名刺",
  "item.minecraft.nautilus_shell": "鸚鵡螺殼",
  "item.minecraft.nautilus_spawn_egg": "孳鸚鵡螺之卵",
  "item.minecraft.nether_brick": "焱界磚",
  "item.minecraft.nether_star": "焱界之星",
  "item.minecraft.nether_wart": "焱界疣",
  "item.minecraft.netherite_axe": "玄鈺斧",
  "item.minecraft.netherite_boots": "玄鈺鞾",
  "item.minecraft.netherite_chestplate": "玄鈺鎧",
  "item.minecraft.netherite_helmet": "玄鈺胄",
  "item.minecraft.netherite_hoe": "玄鈺鋤",
  "item.minecraft.netherite_horse_armor": "玄鈺馬甲",
  "item.minecraft.netherite_ingot": "玄鈺錠",
  "item.minecraft.netherite_leggings": "玄鈺護腿",
  "item.minecraft.netherite_nautilus_armor": "玄鈺鸚鵡螺甲",
  "item.minecraft.netherite_pickaxe": "玄鈺鎬",
  "item.minecraft.netherite_scrap": "玄鈺殘片",
  "item.minecraft.netherite_shovel": "玄鈺鍁",
  "item.minecraft.netherite_spear": "玄鈺槊",
  "item.minecraft.netherite_sword": "玄鈺劍",
  "item.minecraft.netherite_upgrade_smithing_template": "鍛模",
  "item.minecraft.netherite_upgrade_smithing_template.new": "玄鈺之昇",
  "item.minecraft.oak_boat": "柞舟",
  "item.minecraft.oak_chest_boat": "柞艚",
  "item.minecraft.ocelot_spawn_egg": "孳虎貓之卵",
  "item.minecraft.ominous_bottle": "厄甁",
  "item.minecraft.ominous_trial_key": "厄煉管",
  "item.minecraft.orange_bundle": "橙皮囊",
  "item.minecraft.orange_dye": "橙染",
  "item.minecraft.orange_harness": "橙轡",
  "item.minecraft.painting": "畫",
  "item.minecraft.pale_oak_boat": "縞柞舟",
  "item.minecraft.pale_oak_chest_boat": "縞柞艚",
  "item.minecraft.panda_spawn_egg": "孳貓熊之卵",
  "item.minecraft.paper": "紙",
  "item.minecraft.parched_spawn_egg": "孳枯髑之卵",
  "item.minecraft.parrot_spawn_egg": "孳鸚鵡之卵",
  "item.minecraft.phantom_membrane": "魘靈膜",
  "item.minecraft.phantom_spawn_egg": "孳魘靈之卵",
  "item.minecraft.pig_spawn_egg": "孳豕之卵",
  "item.minecraft.piglin_banner_pattern": "旗楷",
  "item.minecraft.piglin_banner_pattern.desc": "豕鼻紋",
  "item.minecraft.piglin_banner_pattern.new": "豕鼻紋旗楷",
  "item.minecraft.piglin_brute_spawn_egg": "孳暴豕靈之卵",
  "item.minecraft.piglin_spawn_egg": "孳豕靈之卵",
  "item.minecraft.pillager_spawn_egg": "孳劫寇之卵",
  "item.minecraft.pink_bundle": "紅皮囊",
  "item.minecraft.pink_dye": "紅染",
  "item.minecraft.pink_harness": "紅轡",
  "item.minecraft.pitcher_plant": "小人蘭",
  "item.minecraft.pitcher_pod": "小人蘭莢",
  "item.minecraft.plenty_pottery_shard": "稷陶片",
  "item.minecraft.plenty_pottery_sherd": "稷陶片",
  "item.minecraft.poisonous_potato": "毒洋芋",
  "item.minecraft.polar_bear_spawn_egg": "孳雪熊之卵",
  "item.minecraft.popped_chorus_fruit": "裂頌緲果",
  "item.minecraft.porkchop": "生豕肉",
  "item.minecraft.potato": "洋芋",
  "item.minecraft.potion": "藥劑",
  "item.minecraft.potion.effect.awkward": "粗劑",
  "item.minecraft.potion.effect.empty": "空劑",
  "item.minecraft.potion.effect.fire_resistance": "抗火劑",
  "item.minecraft.potion.effect.harming": "瞬傷劑",
  "item.minecraft.potion.effect.healing": "瞬療劑",
  "item.minecraft.potion.effect.infested": "蟫蝕劑",
  "item.minecraft.potion.effect.invisibility": "隱劑",
  "item.minecraft.potion.effect.leaping": "捷劑",
  "item.minecraft.potion.effect.levitation": "浮劑",
  "item.minecraft.potion.effect.luck": "幸劑",
  "item.minecraft.potion.effect.mundane": "凡劑",
  "item.minecraft.potion.effect.night_vision": "夜視劑",
  "item.minecraft.potion.effect.oozing": "滲膠劑",
  "item.minecraft.potion.effect.poison": "毒劑",
  "item.minecraft.potion.effect.regeneration": "甦劑",
  "item.minecraft.potion.effect.slow_falling": "輕劑",
  "item.minecraft.potion.effect.slowness": "緩劑",
  "item.minecraft.potion.effect.strength": "力劑",
  "item.minecraft.potion.effect.swiftness": "速劑",
  "item.minecraft.potion.effect.thick": "濁劑",
  "item.minecraft.potion.effect.turtle_master": "龜仙之劑",
  "item.minecraft.potion.effect.water": "水甁",
  "item.minecraft.potion.effect.water_breathing": "水肺劑",
  "item.minecraft.potion.effect.weakness": "虛劑",
  "item.minecraft.potion.effect.weaving": "綴絲劑",
  "item.minecraft.potion.effect.wind_charged": "厲風劑",
  "item.minecraft.pottery_shard_archer": "射陶片",
  "item.minecraft.pottery_shard_arms_up": "肱陶片",
  "item.minecraft.pottery_shard_prize": "寳陶片",
  "item.minecraft.pottery_shard_skull": "顱陶片",
  "item.minecraft.powder_snow_bucket": "齏雪桶",
  "item.minecraft.prismarine_crystals": "海磷晶",
  "item.minecraft.prismarine_shard": "海磷殘片",
  "item.minecraft.prize_pottery_shard": "寳陶片",
  "item.minecraft.prize_pottery_sherd": "寳陶片",
  "item.minecraft.pufferfish": "河豚",
  "item.minecraft.pufferfish_bucket": "河豚桶",
  "item.minecraft.pufferfish_spawn_egg": "孳河豚之卵",
  "item.minecraft.pumpkin_pie": "南瓜餠",
  "item.minecraft.pumpkin_seeds": "南瓜種",
  "item.minecraft.purple_bundle": "紫皮囊",
  "item.minecraft.purple_dye": "紫染",
  "item.minecraft.purple_harness": "紫轡",
  "item.minecraft.quartz": "石英",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.rabbit_foot": "兔足",
  "item.minecraft.rabbit_hide": "兔皮",
  "item.minecraft.rabbit_spawn_egg": "孳兔之卵",
  "item.minecraft.rabbit_stew": "兔肉羹",
  "item.minecraft.raiser_armor_trim_smithing_template": "鍛模",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "牧民甲紋",
  "item.minecraft.ravager_spawn_egg": "孳劫獸之卵",
  "item.minecraft.raw_copper": "銅璞",
  "item.minecraft.raw_gold": "馬蹄金",
  "item.minecraft.raw_iron": "砂鐵",
  "item.minecraft.recovery_compass": "溯魂司南",
  "item.minecraft.red_bundle": "赤皮囊",
  "item.minecraft.red_dye": "赤染",
  "item.minecraft.red_harness": "赤轡",
  "item.minecraft.redstone": "赤石末",
  "item.minecraft.resin_brick": "樹香磚",
  "item.minecraft.resin_clump": "樹香",
  "item.minecraft.rib_armor_trim_smithing_template": "鍛模",
  "item.minecraft.rib_armor_trim_smithing_template.new": "脅肋甲紋",
  "item.minecraft.rotten_flesh": "胔",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.salmon": "生鮭",
  "item.minecraft.salmon_bucket": "鮭桶",
  "item.minecraft.salmon_spawn_egg": "孳鮭之卵",
  "item.minecraft.scrape_pottery_sherd": "削陶片",
  "item.minecraft.scute": "鱗",
  "item.minecraft.sentry_armor_trim_smithing_template": "鍛模",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "斥候甲紋",
  "item.minecraft.shaper_armor_trim_smithing_template": "鍛模",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "巧匠甲紋",
  "item.minecraft.sheaf_pottery_shard": "秉陶片",
  "item.minecraft.sheaf_pottery_sherd": "秉陶片",
  "item.minecraft.shears": "鉸",
  "item.minecraft.sheep_spawn_egg": "孳綿羊之卵",
  "item.minecraft.shelter_pottery_shard": "蔭陶片",
  "item.minecraft.shelter_pottery_sherd": "蔭陶片",
  "item.minecraft.shield": "盾",
  "item.minecraft.shield.black": "黑盾",
  "item.minecraft.shield.blue": "靛盾",
  "item.minecraft.shield.brown": "褐盾",
  "item.minecraft.shield.cyan": "黛盾",
  "item.minecraft.shield.gray": "灰盾",
  "item.minecraft.shield.green": "綠盾",
  "item.minecraft.shield.light_blue": "縹盾",
  "item.minecraft.shield.light_gray": "蒼盾",
  "item.minecraft.shield.lime": "翠盾",
  "item.minecraft.shield.magenta": "赬盾",
  "item.minecraft.shield.orange": "橙盾",
  "item.minecraft.shield.pink": "紅盾",
  "item.minecraft.shield.purple": "紫盾",
  "item.minecraft.shield.red": "赤盾",
  "item.minecraft.shield.white": "白盾",
  "item.minecraft.shield.yellow": "黃盾",
  "item.minecraft.shulker_shell": "匿贆殼",
  "item.minecraft.shulker_spawn_egg": "孳匿贆之卵",
  "item.minecraft.sign": "牌",
  "item.minecraft.silence_armor_trim_smithing_template": "鍛模",
  "item.minecraft.silence_armor_trim_smithing_template.new": "寂靜甲紋",
  "item.minecraft.silverfish_spawn_egg": "孳蟫之卵",
  "item.minecraft.skeleton_horse_spawn_egg": "孳骷髏馬之卵",
  "item.minecraft.skeleton_spawn_egg": "孳骷髏之卵",
  "item.minecraft.skull_banner_pattern": "旗楷",
  "item.minecraft.skull_banner_pattern.desc": "髑顱紋",
  "item.minecraft.skull_banner_pattern.new": "髑顱紋旗楷",
  "item.minecraft.skull_pottery_shard": "顱陶片",
  "item.minecraft.skull_pottery_sherd": "顱陶片",
  "item.minecraft.slime_ball": "黏膠團",
  "item.minecraft.slime_spawn_egg": "孳黏膠魔之卵",
  "item.minecraft.smithing_template": "鍛模",
  "item.minecraft.smithing_template.applies_to": "適於：",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "置鑄錠晶石",
  "item.minecraft.smithing_template.armor_trim.applies_to": "甲胄",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "置甲胄",
  "item.minecraft.smithing_template.armor_trim.ingredients": "鑄錠晶石",
  "item.minecraft.smithing_template.ingredients": "原料：",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "置玄鈺錠",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "金剛石甲胄",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "置金剛石兵革器具",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "玄鈺錠",
  "item.minecraft.smithing_template.upgrade": "昇：",
  "item.minecraft.sniffer_spawn_egg": "孳嗅獸之卵",
  "item.minecraft.snort_pottery_shard": "嗅陶片",
  "item.minecraft.snort_pottery_sherd": "嗅陶片",
  "item.minecraft.snout_armor_trim_smithing_template": "鍛模",
  "item.minecraft.snout_armor_trim_smithing_template.new": "豕鼻甲紋",
  "item.minecraft.snow_golem_spawn_egg": "孳雪傀儡之卵",
  "item.minecraft.snowball": "雪團",
  "item.minecraft.spectral_arrow": "爍靈矢",
  "item.minecraft.spider_eye": "蛛目",
  "item.minecraft.spider_spawn_egg": "孳蛛之卵",
  "item.minecraft.spire_armor_trim_smithing_template": "鍛模",
  "item.minecraft.spire_armor_trim_smithing_template.new": "旋塔甲紋",
  "item.minecraft.splash_potion": "噴劑",
  "item.minecraft.splash_potion.effect.awkward": "粗噴劑",
  "item.minecraft.splash_potion.effect.empty": "空噴劑",
  "item.minecraft.splash_potion.effect.fire_resistance": "抗火噴劑",
  "item.minecraft.splash_potion.effect.harming": "瞬傷噴劑",
  "item.minecraft.splash_potion.effect.healing": "瞬療噴劑",
  "item.minecraft.splash_potion.effect.infested": "蟫蝕噴劑",
  "item.minecraft.splash_potion.effect.invisibility": "隱噴劑",
  "item.minecraft.splash_potion.effect.leaping": "捷噴劑",
  "item.minecraft.splash_potion.effect.levitation": "浮噴劑",
  "item.minecraft.splash_potion.effect.luck": "幸噴劑",
  "item.minecraft.splash_potion.effect.mundane": "凡噴劑",
  "item.minecraft.splash_potion.effect.night_vision": "夜視噴劑",
  "item.minecraft.splash_potion.effect.oozing": "滲膠噴劑",
  "item.minecraft.splash_potion.effect.poison": "毒噴劑",
  "item.minecraft.splash_potion.effect.regeneration": "甦噴劑",
  "item.minecraft.splash_potion.effect.slow_falling": "輕噴劑",
  "item.minecraft.splash_potion.effect.slowness": "緩噴劑",
  "item.minecraft.splash_potion.effect.strength": "力噴劑",
  "item.minecraft.splash_potion.effect.swiftness": "速噴劑",
  "item.minecraft.splash_potion.effect.thick": "濁噴劑",
  "item.minecraft.splash_potion.effect.turtle_master": "龜仙噴劑",
  "item.minecraft.splash_potion.effect.water": "水噴劑",
  "item.minecraft.splash_potion.effect.water_breathing": "水肺噴劑",
  "item.minecraft.splash_potion.effect.weakness": "虛噴劑",
  "item.minecraft.splash_potion.effect.weaving": "綴絲噴劑",
  "item.minecraft.splash_potion.effect.wind_charged": "厲風噴劑",
  "item.minecraft.spruce_boat": "樅舟",
  "item.minecraft.spruce_chest_boat": "樅艚",
  "item.minecraft.spyglass": "望遠鏡",
  "item.minecraft.squid_spawn_egg": "孳鰂之卵",
  "item.minecraft.stick": "棍",
  "item.minecraft.stone_axe": "石斧",
  "item.minecraft.stone_hoe": "石鋤",
  "item.minecraft.stone_pickaxe": "石鎬",
  "item.minecraft.stone_shovel": "石鍁",
  "item.minecraft.stone_spear": "石槊",
  "item.minecraft.stone_sword": "石劍",
  "item.minecraft.stray_spawn_egg": "孳流髑之卵",
  "item.minecraft.strider_spawn_egg": "孳熾足獸之卵",
  "item.minecraft.string": "綫",
  "item.minecraft.sugar": "糖",
  "item.minecraft.suspicious_stew": "謎羹",
  "item.minecraft.sweet_berries": "甜莓",
  "item.minecraft.tadpole_bucket": "蝌蚪桶",
  "item.minecraft.tadpole_spawn_egg": "孳蝌蚪之卵",
  "item.minecraft.tide_armor_trim_smithing_template": "鍛模",
  "item.minecraft.tide_armor_trim_smithing_template.new": "潮汐甲紋",
  "item.minecraft.tipped_arrow": "藥矢",
  "item.minecraft.tipped_arrow.effect.awkward": "藥矢",
  "item.minecraft.tipped_arrow.effect.empty": "空藥矢",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "抗火矢",
  "item.minecraft.tipped_arrow.effect.harming": "瞬傷矢",
  "item.minecraft.tipped_arrow.effect.healing": "瞬療矢",
  "item.minecraft.tipped_arrow.effect.infested": "蟫蝕矢",
  "item.minecraft.tipped_arrow.effect.invisibility": "隱矢",
  "item.minecraft.tipped_arrow.effect.leaping": "捷矢",
  "item.minecraft.tipped_arrow.effect.levitation": "浮矢",
  "item.minecraft.tipped_arrow.effect.luck": "幸矢",
  "item.minecraft.tipped_arrow.effect.mundane": "藥矢",
  "item.minecraft.tipped_arrow.effect.night_vision": "夜視矢",
  "item.minecraft.tipped_arrow.effect.oozing": "滲膠矢",
  "item.minecraft.tipped_arrow.effect.poison": "毒矢",
  "item.minecraft.tipped_arrow.effect.regeneration": "甦矢",
  "item.minecraft.tipped_arrow.effect.slow_falling": "輕矢",
  "item.minecraft.tipped_arrow.effect.slowness": "緩矢",
  "item.minecraft.tipped_arrow.effect.strength": "力矢",
  "item.minecraft.tipped_arrow.effect.swiftness": "速矢",
  "item.minecraft.tipped_arrow.effect.thick": "藥矢",
  "item.minecraft.tipped_arrow.effect.turtle_master": "龜仙之矢",
  "item.minecraft.tipped_arrow.effect.water": "噴矢",
  "item.minecraft.tipped_arrow.effect.water_breathing": "水肺矢",
  "item.minecraft.tipped_arrow.effect.weakness": "虛矢",
  "item.minecraft.tipped_arrow.effect.weaving": "綴絲矢",
  "item.minecraft.tipped_arrow.effect.wind_charged": "厲風矢",
  "item.minecraft.tnt_minecart": "灹藥礦車",
  "item.minecraft.torchflower_seeds": "炬蓮種",
  "item.minecraft.totem_of_undying": "保命符",
  "item.minecraft.trader_llama_spawn_egg": "孳商駝之卵",
  "item.minecraft.trial_key": "煉管",
  "item.minecraft.trident": "三叉戟",
  "item.minecraft.tropical_fish": "賞魚",
  "item.minecraft.tropical_fish_bucket": "賞魚桶",
  "item.minecraft.tropical_fish_spawn_egg": "孳賞魚之卵",
  "item.minecraft.turtle_helmet": "龜殼",
  "item.minecraft.turtle_scute": "海龜鱗",
  "item.minecraft.turtle_spawn_egg": "孳海龜之卵",
  "item.minecraft.vex_armor_trim_smithing_template": "鍛模",
  "item.minecraft.vex_armor_trim_smithing_template.new": "惱鬼甲紋",
  "item.minecraft.vex_spawn_egg": "孳惱鬼之卵",
  "item.minecraft.villager_spawn_egg": "孳鄉民之卵",
  "item.minecraft.vindicator_spawn_egg": "孳斫仇者之卵",
  "item.minecraft.wandering_trader_spawn_egg": "孳行商之卵",
  "item.minecraft.ward_armor_trim_smithing_template": "鍛模",
  "item.minecraft.ward_armor_trim_smithing_template.new": "監守甲紋",
  "item.minecraft.warden_spawn_egg": "孳監守之卵",
  "item.minecraft.warped_fungus_on_a_stick": "譎蕈釣竿",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "鍛模",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "嚮導甲紋",
  "item.minecraft.wheat": "麥",
  "item.minecraft.wheat_seeds": "麥種",
  "item.minecraft.white_bundle": "素皮囊",
  "item.minecraft.white_dye": "白染",
  "item.minecraft.white_harness": "白轡",
  "item.minecraft.wild_armor_trim_smithing_template": "鍛模",
  "item.minecraft.wild_armor_trim_smithing_template.new": "林野甲紋",
  "item.minecraft.wind_charge": "風彈",
  "item.minecraft.witch_spawn_egg": "孳巫之卵",
  "item.minecraft.wither_skeleton_spawn_egg": "孳凋靈骷髏之卵",
  "item.minecraft.wither_spawn_egg": "孳凋靈之卵",
  "item.minecraft.wolf_armor": "狼甲",
  "item.minecraft.wolf_spawn_egg": "孳狼之卵",
  "item.minecraft.wooden_axe": "木斧",
  "item.minecraft.wooden_hoe": "木鋤",
  "item.minecraft.wooden_pickaxe": "木鎬",
  "item.minecraft.wooden_shovel": "木鍁",
  "item.minecraft.wooden_spear": "木槊",
  "item.minecraft.wooden_sword": "木劍",
  "item.minecraft.writable_book": "書與筆",
  "item.minecraft.written_book": "成書",
  "item.minecraft.yellow_bundle": "黃皮囊",
  "item.minecraft.yellow_dye": "黃染",
  "item.minecraft.yellow_harness": "黃轡",
  "item.minecraft.zoglin_spawn_egg": "孳屍化獷豕之卵",
  "item.minecraft.zombie_horse_spawn_egg": "孳屍馬之卵",
  "item.minecraft.zombie_nautilus_spawn_egg": "孳屍化鸚鵡螺之卵",
  "item.minecraft.zombie_spawn_egg": "孳殭屍之卵",
  "item.minecraft.zombie_villager_spawn_egg": "孳屍化鄉民之卵",
  "item.minecraft.zombified_piglin_spawn_egg": "孳屍化豕靈之卵"
}
export const lzh = items; 
